// prettier-ignore-start
import { ChangeDetectorRef, Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core'
import { Subscription } from 'rxjs';
import { MapComponent } from './map/map.component';
import * as Utils from '../../core/lib/utils';
import { environment } from 'src/environments/environment';
import { CheckFeasibilityRequest, SingleRequest } from './models/check-feasibility-request';
import { HelpersService } from 'src/core/services/helpers.service';
import { LandingPageService } from './landing-page.service';
import { Point } from './models/point';
import { MatDialog } from '@angular/material/dialog';
import { LegendaComponent } from '../shared/legenda/legenda.component';
import { DialogUploadComponent } from '../shared/dialog-upload/dialog-upload.component';
import { ActivatedRoute, Params } from '@angular/router';
import { Config, ConfigPoint, LANDING_CONFIGURATION, SLUG_CONVERTER } from 'src/core/config/landing-config';
import { BuildingClusters, HealthcareClusters, Pop, SchoolClusters, User } from 'src/core/models/models';
import { ModalMultiBuildingComponent } from '../shared/modal-multi-building/modal-multi-building.component';
import { NgZone } from '@angular/core';
import { Bts, BtsList } from 'src/core/models/bts';
import { ModalMultiPointsComponent } from '../shared/modal-multi-points/modal-multi-points.component';
import { CoordinatesSearchComponent } from './coordinates-search/coordinates-search.component';
import { BasicAutocompleteComponent } from './basic-autocomplete/basic-autocomplete.component';
import { RpiList } from 'src/core/models/rpi';
import { WavelengthList } from 'src/core/models/wavelength';
import { ModalSanitaScuoleComponent } from '../shared/modal-sanita-scuole/modal-sanita-scuole.component';

type ModeType = 'add' | 'edit' | 'acc' | 'div'
type PointSide = 'b_end' | 'a_end';
type ConfigPointMethodKey = Exclude<
  keyof ConfigPoint,
  'default_method' | 'switch_methods' | 'popAndPoiAutocomplete'
>;



@Component({
    selector: 'app-landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.scss'],
})

export class LandingPageComponent implements OnInit {
    geocoder: google.maps.Geocoder;
    env = environment;
    @ViewChild('modalMultiBuilding', { static: true }) modalMultiBuilding: ModalMultiBuildingComponent;
    @ViewChild('modalComponentSS', { static: true }) modalComponentSS: ModalSanitaScuoleComponent;
    @ViewChild('modalMultiPoints', { static: true }) modalMultiPoints: ModalMultiPointsComponent;
    @ViewChild('map', { static: true }) map: MapComponent;
    @ViewChildren('coordinatesSearch') coordinatesSearch: QueryList<CoordinatesSearchComponent>;
    @ViewChildren('basicAutocomplete') basicAutocomplete: QueryList<BasicAutocompleteComponent>;

    //BEA Multiple point Management
    max_points: number;

    //gestione trasloco (add|edit) / longdistance (acc|div)
    idRisorsa: string;
    mode: ModeType;
    index: string;



    //todo aggiungere eventuali landing a cui checkare il default per abilitare l'add point
    landingPagesToCheck = ['bea'];

    //Anno Bando
    bandi: any;
    annoBandoOptions: any = [];

    //landing page list where anno_bando is required
    annoBandoRequiredList = ['sanitadarkfiber', 'sanita', 'scuole', 'scuoledarkfiber']; //todo aggiungere eventuali landingPage

    popPoiClickableLandingList = ['housing']; //todo aggiungere eventuali landingPage

    annoBandoRequired: boolean;
    annoBando: string;
    isAnnoBandoDropdownVisible: boolean;


    buildingClusters: BuildingClusters = null;
    schoolClusters: SchoolClusters = null;
    healthcareClusters: HealthcareClusters = null;
    btsClusters = null;
    puntiIntermediClusters = null;

    kmlList: any;
    schoolList: any;
    healthcareList: any;
    poiList: any;
    pfsList: any;
    roeList: any;
    cnoList: any;
    pozzettoList: any;
    roeListAutocomplete: any[] = [];
    cnoListAutocomplete: any[] = [];
    pozzettiListAutocomplete: any[] = [];
    popListAutocomplete: any[] = [];
    wavelengthList: WavelengthList = { POP: [], POI: [] };
    wavelengthLists: WavelengthList[] = [ // TODO gestire dinamicamente la quantità di punti
        { POP: [], POI: [] },
        { POP: [], POI: [] }
    ];
    btsList: BtsList = { NOA: [], BUILDING: [] };
    btsLists: BtsList[] = [ // TODO gestire dinamicamente la quantità di punti
        { NOA: [], BUILDING: [] },
        { NOA: [], BUILDING: [] }
    ];
    rpiList: RpiList = { ROE: [], CNO: [], POZZETTO: [] };
    citiesRpi: any = { ROE: [], CNO: [], POZZETTO: [] };

    citiesWavelength: any = { POP: [], PCN: [], XPOP: [] };

    citiesNoa: any;
    citiesBuilding: any;
    citiesPop: any;
    citiesPoi: any;

    popLabels: string[] = []
    poiLabels: string[] = []
    poiByCityLabels: string[] = []
    popByCityLabels: string[] = []
    cityLabelPop: string[] = []
    cityLabelPoi: string[] = []

    abPops: Pop[] = [];
    cdPops: Pop[] = [];
    agfPops: Pop[] = [];
    olaPops: Pop[] = [];

    schoolForMap: any[] = [];
    healthcareForMap: any[] = [];
    showToast = false;
    tempPoint: Point;
    modalBuildings = [];
    modalScuoleSanita = [];
    modalType = '';
    modalPoints = null;
    request = { p1: {}, p2: {}, p3: {} };
    requestArray: CheckFeasibilityRequest[] = [];
    selectedPoints: Point[] = [];
    checkPointEnd: 0 | 1 | 2 = null;
    modalEnd: 0 | 1 | 2 = null;
    pointFromModal = false;
    pointFromModalSanita = false;
    requestsType: string[] = [];
    requestsTypeRpi: string[] = [];
    requestsTypeWavelength: string[] = [];
    researchMethods: string[] = [];
    searchedType: any = { key: null, value: null };
    wait: boolean = false;
    cities: string[] = [];
    labels: string[] = [];
    labelsRpi: string[] = [];
    public inputsNumber: number = 0;
    initComponent: boolean = true;
    labelsWavelength: string[] = [];
    private getPopBBoxSubscription$: Subscription;
    private searchBuildingPlaceholdersSubscription$: Subscription;
    private getSchoolSubscription$: Subscription;
    private getHealthcareSubscription$: Subscription;
    private getBtsBboxSubscription$: Subscription;
    private getPuntiIntermediBboxSubscription$: Subscription;
    public switchValues = [[], [], [], [], [], [], [], [], [], []]
    public switchValuesRpi = [
        { value: 'city_rpi', viewValue: 'City' },
        { value: 'id_rpi', viewValue: 'ID' }
    ];
    public switchValuesWavelength = [
        { value: 'city_wavelength', viewValue: 'City' },
        { value: 'id_wavelength', viewValue: 'ID' }
    ];
    public user: User;
    documentId: number;
    showMassiveDetail = false;
    additionalAutocompletes = [false, false]; // TODO gestire dinamicamente la quantità di punti
    public canAddPoints = false;
    config: Config = this.env.controls.unique_environment ? LANDING_CONFIGURATION[SLUG_CONVERTER[window.location.pathname.split('/')[1]]] : LANDING_CONFIGURATION[this.env.serviceSlug];
    public pointsConfig = this.config.multiple_points.points;
    public puntiIntermediTypesTranslated = [];
    public wavelengthTypesTranslated = [];
    public puntiIntermediTypes = [];
    private actualPoint: { long_provincia: string, comune: string, end: number } = { long_provincia: '', comune: '', end: 0 };
    public popPcnXpopTypes = [];
    public statusComune: string = '';
    private a_endCities: { default: number, cities: any, is_aend_allowed: boolean };
    private isOutsideItaly: boolean = false;
    public isEditable: boolean = true;
    public isTrasloco: boolean = false;
    public isTraslocoUpload: boolean = false;
    public pointTrasloco: any;
    public endEditablePoint: any;
    private tmpIdTrasloco: any;
    isTraslocoEnabled: boolean = true;

    isLongLineCheck = false;
    private RequiresNumberedMakers = ["bea", "darkfiber"];

    public resKeys = [];
    public responseTmp = {}


    private geocoderResults: any;

    get inputNames() {
        if (this.config.multiple_points.variable) {
            return Utils.inputNamesVariables
        } else {
            return Utils.inputNames
        }
    }

    get savedFile() {
        return this.landingPageService.fileToUpload;
    }

    // private test_a_end = {
    //   "default": 1,
    //   "cities": {
    //     "BA": {
    //       "Bari": 0
    //     },
    //     "MI": {
    //       "Milano": 1,
    //       "Cinisello Balsamo": 2,
    //       "San Donato Milanese": 0,
    //       "Rozzano": 0,
    //       "Opera": 1,
    //     },
    //     "TO": {
    //       "Torino": 1,
    //       "Venaria Reale": 0,
    //       "Moncalieri": 2
    //     },
    //     "BO": {
    //       "Bologna": 0
    //     },
    //     "CH": {
    //       "San Giovanni teatino": 2
    //     }
    //   },
    //   is_aend_allowed: false
    // };


    get feasibilityBlocked() {
        if (this.config.data.dynamic_aend_name !== '' && this.config.data.dynamic_aend_name !== 'BEA' && this.a_endCities) {
            const place: Point = this.selectedPoints[0];
            const point_dynamic: { long_provincia: string, comune: string } = place ? this.actualPoint : {} as { long_provincia: string, comune: string };
            // Controlla se c'è solo un punto selezionato
            const isSinglePoint = this.selectedPoints.length <= 1;
            // Controlla se l'etichetta del secondo punto è assente
            const isLabelAbsent = isSinglePoint || !this.selectedPoints[1]?.label;
            if ((this.actualPoint?.long_provincia !== '' && this.actualPoint?.comune && this.actualPoint?.comune !== '') && (this.actualPoint?.long_provincia === point_dynamic?.long_provincia && this.actualPoint?.comune && this.actualPoint?.comune === point_dynamic?.comune)) {
                // Ottieni la provincia e il comune del punto attuale
                const { long_provincia: province, comune } = point_dynamic;
                const cities = this.a_endCities.cities;
                // Ottieni lo stato della città corrispondente alla provincia e al comune attuali
                const cityStatus = cities[province]?.[comune];
                if (cityStatus === 0 && this.actualPoint.end === 0 || ((!cityStatus && this.actualPoint.end === 0) && this.a_endCities?.default === 0)) {
                    while (this.selectedPoints.length > 1) {
                        this.removeSearchInput(1);
                        this.map.removeMarkersByIndex(2);
                        this.canAddPoints = false;
                    }
                }
            }
            if (isLabelAbsent) {
                // Ottieni la provincia e il comune del punto attuale
                const { long_provincia: province, comune } = this.actualPoint;
                const cities = this.a_endCities && this.a_endCities.cities ? this.a_endCities.cities : {};
                // Ottieni lo stato della città corrispondente alla provincia e al comune attuali
                const cityStatus = cities[province]?.[comune];
                if (cityStatus !== undefined && isSinglePoint) {
                    return cityStatus === 2;
                }
            }
            return isSinglePoint && this.a_endCities?.default === 2;
        }
    }

    public canAddPointsOptional(isTemp = false) {
        if (this.config.data.dynamic_aend_name !== '' && this.a_endCities) {
            // Se non è configurato per punti multipli, imposta canAddPoints a false e rimuovi eventuali punti in eccesso
            if (!this.config.multiple_points.variable) {
                this.canAddPoints = false;
                if (this.selectedPoints.length && this.selectedPoints.length > this.config.multiple_points.initial_points.length) {
                    this.removeSearchInput(1);
                }
                return;
            }
            // Se non ci sono punti selezionati o ce ne sono più di uno, non fare nulla
            if (this.selectedPoints.length !== 1) {
                return;
            }
            // Ottieni la provincia e il comune del punto attuale (se è confermato) o del punto precedente (se è temp)

            const province = !isTemp ? this.actualPoint.long_provincia : this.helpersService.getInfoSmall(this.selectedPoints[0].address_components, ['administrative_area_level_2'], 'short_name');
            const comune = !isTemp ? this.actualPoint.comune : this.helpersService.retComune(this.selectedPoints[0].address_components);

            // Ottieni lo stato di input in base alla configurazione della città
            const inputStatus = this.a_endCities.cities[province]?.[comune] ?? this.a_endCities.default;
            // Imposta canAddPoints in base allo stato di input
            this.canAddPoints = this.getCanAddPointsStatus(inputStatus);
        }
    }

    private getCanAddPointsStatus(status) {
        // Ritorna true solo se lo stato è 1 o 2, altrimenti ritorna false
        return status === 1 || status === 2;
    }

    get isButtonEnabled() {
        /*
        console.table([
            ['isTraslocoEnabled', this.isTraslocoEnabled],
            ['config.data.feasibilityEnabled', this.config.data.feasibilityEnabled],
            ['initComponent', this.initComponent],
            ['isOutsideItaly', this.isOutsideItaly],
            ['selectedPoints[0]', this.selectedPoints[0]],
            ['selectedPoints[1]', this.selectedPoints[1]],
            ['selectedPoints[2]', this.selectedPoints[2]],
            ['selectedPoints[0]?.label', this.selectedPoints[0]?.label],
            ['selectedPoints[1]?.label', this.selectedPoints[1]?.label],
            ['selectedPoints[2]?.label', this.selectedPoints[2]?.label],
        ])
        */
        if (this.env.serviceSlug == 'kit' && ((this.selectedPoints[0] && this.selectedPoints[0]?.label) || (this.selectedPoints[1] && this.selectedPoints[1]?.label))) {
            return true;
        }

        //se DF long distance -> devo avere tutti e 2 i punti selezionati
        if (this.isLongLineCheck) {
            return !this.selectedPoints.some(point => {
                // se il punto è nullo o un oggetto vuoto → disabilita
                return !point || Object.keys(point).length === 0;
            });
        }


        //nel caso io abbia la dropdown per l'anno bando e non sia selezionato
        if (this.isAnnoBandoDropdownVisible && !this.annoBando) {
            return false;
        }


        const hasInvalidPoint = this.selectedPoints.some((point, index) => index <= 9 && point && !point.label);

        if (
            !this.isTraslocoEnabled ||
            !this.config.data.feasibilityEnabled ||
            this.initComponent ||
            this.isOutsideItaly ||
            (
                !this.selectedPoints[0]?.label || hasInvalidPoint ||
                (this.selectedPoints[1] && !this.selectedPoints[1].label) ||
                (this.selectedPoints[2] && !this.selectedPoints[2].label)
            )
        ) {
            // console.log('isButtonEnabled', false)
            return false;
        } else {
            // console.log('isButtonEnabled', true)
            return true;
        }
    }

    get isWaitingBuildings() {
        return this.landingPageService.waitBuildings;
    }

    // Divider to show in case of research method by city is enabled
    get showDivider() {
        if (this.config.multiple_points.max <= 1) {
            return false;
        } else {
            for (const i of this.config?.multiple_points?.initial_points) {
                return this.pointsConfig[i].city_noa || this.pointsConfig[i].city_building ? true : false;
            }
        }
    }

    constructor(
        public helpersService: HelpersService,
        public landingPageService: LandingPageService,
        private dialog: MatDialog,
        private activatedRoute: ActivatedRoute,
        private cdr: ChangeDetectorRef,
        public zone: NgZone) {
        this.geocoder = new google.maps.Geocoder();
    }

    ngOnInit() {
        if (this.env.controls.massive_import_two_steps) {
            this.activatedRoute.queryParams.subscribe((params: Params) => {
                if (params['id']) {
                    this.documentId = params['id'];
                    this.showMassiveDetail = true;
                }
            });
        }
        //leggo i query params
        this.activatedRoute.queryParams.subscribe(params => {

            //trasloco
            this.idRisorsa = params['id_risorsa'];
            this.mode = params['mode'];
            this.index = params['index'];

            //se ho id risorsa controllo il mode per definire la tipologia di operazione
            if (this.idRisorsa) {
                if (this.mode === 'add' || this.mode === 'edit') {
                    this.isTrasloco = true
                } else if (this.mode === 'acc' || this.mode === 'div') {
                    this.isLongLineCheck = true
                } else {
                    this.isTrasloco = this.isLongLineCheck = false
                }
            }

        });

        this.startComponent()

        //se TRASLOCO
        if (this.isTrasloco) {
            this.isTraslocoUpload = true;
            if (this.config.data.dynamic_aend_name !== '') {

                this.landingPageService.getConfigurations().subscribe(config => {
                    this.a_endCities = config.aend_cities;
                    this.bandi = config.bandi;
                })
                this.decodeIdTrasloco(this.idRisorsa);
            }
        }
        this.checkAnnoBandoRequired();
    }

    startComponent() {
        this.landingPageService.getUserInfo().subscribe(res => {
            this.user = res;
            this.initPointToLoad();
            this.initComponent = false;
        });

        //SKIPPO se ho iru_code 
        if (this.config.data.dynamic_aend_name !== '' && !this.isLongLineCheck) {
            this.landingPageService.getConfigurations().subscribe(config => {
                this.a_endCities = config.aend_cities;
                this.max_points = config.max_points;
                this.bandi = config.bandi;
                this.canAddPointsOptional();
                //se mi arriva dalla configurazione un maxpoint lo vado a sovrascrivere
                if (config.max_points != null) {
                    this.config.multiple_points.max = this.max_points;
                }

                //Gestione per configurazioni che non necessitano di aend_cities ma devono poter aggiungere punti
                if (this.a_endCities == null && this.landingPagesToCheck.includes(this.env.serviceSlug) && !this.mode) {
                    this.canAddPoints = true;
                }

            })
        }

        //nel caso ho iru code e iru mode nella path faccio il check per l'inizializzazione dei punti iniziali 
        if (this.isLongLineCheck) {
            this.checkIfLongLineRequest()
        }
    }

    initPointToLoad() {
        // POP
        if (this.config.pop.load || this.config.pcn.load || this.config.pop_ola.load || (this.env.controls.agf && this.config.pop_agf.load) || this.env.controls.agf_pop) {
            this.loadPop()
        }
        ;

        // PFS/ROE per rete primaria/secondaria
        let networkLinkTypes = [];
        if (this.config.punti_intermedi && this.config.punti_intermedi.types) {
            Object.keys(this.config.punti_intermedi.types).forEach(t => {
                this.puntiIntermediTypesTranslated.push(Utils.PUNTI_INTERMEDI_LABELS[t]);
                networkLinkTypes.push(t);
            });
            if (networkLinkTypes.length) {
                this.puntiIntermediTypes = networkLinkTypes;
            } else {
                Object.values(Utils.PUNTI_INTERMEDI_KEYS).forEach(el => {
                    this.puntiIntermediTypes.push(el)
                });
            }
            ;
        } else if (this.config.pop_pcn_xpop && this.config.pop_pcn_xpop.types) {
            Object.keys(this.config.pop_pcn_xpop.types).forEach(t => {
                this.wavelengthTypesTranslated.push(Utils.POP_PCN_XPOP_LABELS[t]);
                networkLinkTypes.push(t);
            });
            if (networkLinkTypes.length) {
                this.popPcnXpopTypes = networkLinkTypes;
            } else {
                Object.values(Utils.PUNTI_INTERMEDI_KEYS).forEach(el => {
                    this.puntiIntermediTypes.push(el)
                });
            }
            ;
        } else {
            if (this.config.pfs.load && this.config.pfs.type) {
                networkLinkTypes.push(this.config.pfs.type);
            }
            if (this.config.roe.load && this.config.roe.type) {
                networkLinkTypes.push(this.config.roe.type);
            }
            if (networkLinkTypes.length) {
                this.loadNetworkLinkPoints(networkLinkTypes, this.config.area_types_short)
            }
            ;
        }
        // POI
        if (this.config.poi.load) {
            this.loadPoi()
        }
        ;
        // BTS
        if (this.config.bts.load) {
            this.loadBtsCities(['NOA'])
        }
        ; // default
        // Wavelenght
        if (this.config.pop.loadCities) {
            this.loadWavelenghtCitiesPop(['POP']);
        }
        ; //

        if (this.config.poi.loadCities) {
            this.loadWavelenghtCitiesPoi(['POI']);
        }
        ;


        // KML
        if (this.config.kml) {
            this.loadKml()
        }
        ;
        // aree industriali
        this.getIndustrialArea();
        // gestione numero di input

        if (this.config.multiple_points.initial_points.length > 1 && !this.isTraslocoUpload) {
            this.config.multiple_points.initial_points.forEach(p => {
                this.addSearchInput(p);
            });
        } else {
            this.addSearchInput(this.config.multiple_points.initial_points[0]);
        }

    }

    loadPoi() {
        this.landingPageService.getPoiList(this.user.olocode).subscribe(res => {
            this.poiList = res;
            if (res && this.map && this.config.poi.view_initial) {
                this.map.poiList = this.poiList;
                this.map.setMapButton('poi')
            }
        });
    }

    loadPop() {
        this.landingPageService.getPops().subscribe(res => {
            if (res) {
                const popListAutocomplete = []

                res.forEach((p: Pop) => {
                    popListAutocomplete.push(p)
                });

                this.popListAutocomplete = popListAutocomplete

                if (this.map && (this.config.pop.view_initial || this.config.pcn.view_initial || this.config.pop_agf.view_initial || this.config.pop_ola.view_initial)) {
                    this.map.setMapButton('pops');
                }
            }
        });
    }


    loadNetworkLinkPoints(types, clusters) {
        this.landingPageService.getNetworkLinkPoints(types, clusters).subscribe(res => {
            if (this.map) {
                for (const t of types) {
                    if (res && res.results[t.toUpperCase()]) {
                        (this as any)[t.toLowerCase() + 'List'] = res.results[t.toUpperCase()];
                        this.map[t.toLowerCase() + 'List'] = (this as any)[t.toLowerCase() + 'List'];
                        this.map.setMapButton(t.toLowerCase())
                    }
                }
            }
        });
    }

    loadKml() {
        this.landingPageService.getKMLList().subscribe(res => {
            this.kmlList = res;
        });
    }

    private getIndustrialArea() {
        const industrial_url = environment.BASE_KML_URL + 'industrial-area/areas.kml?version=' + '1';
        this.map.drawIndustrialLayers(industrial_url);
    }

    private blurInputElements() {
        // @ts-ignore
        document.activeElement.blur()
    }

    loadBtsCities(types: string[]) {
        if (types.includes('NOA') && this.citiesNoa && this.citiesNoa.length) {
            types = types.filter(e => e !== 'NOA');
        }
        if (types.includes('BUILDING') && this.citiesBuilding && this.citiesBuilding.length) {
            types = types.filter(e => e !== 'BUILDING');
        }
        if (types && types.length) {
            this.landingPageService.getBtsCities(types).subscribe(res => {
                if (res.results) {
                    if (res.results.NOA) {
                        this.citiesNoa = res.results.NOA;
                    }
                    if (res.results.BUILDING) {
                        this.citiesBuilding = res.results.BUILDING;
                    }
                }
            })
        }
    }

    checkSwitchValues(index) {
        const initialPointIdx = index > 0 ? 'a_end' : 'b_end';

        if (this.pointsConfig[initialPointIdx].pop_pcn_xpop) {
            this.switchValues[index].splice(0, 0, { value: 'city_pop', viewValue: 'Search POP by City' });
            this.switchValues[index].splice(0, 0, { value: 'city_poi', viewValue: 'Search POI by City' });
        }
        if (this.pointsConfig[initialPointIdx].upload && this.config.data.route !== "serviziobea" && !this.isTraslocoUpload && !this.isLongLineCheck) {
            this.switchValues[index].splice(0, 0, { value: 'import', viewValue: 'Upload' });
        }
        if (this.pointsConfig[initialPointIdx].upload && this.config.data.route === "serviziobea" && !this.isTraslocoUpload && !this.isLongLineCheck) {
            this.switchValues[index].splice(0, 0, { value: 'import', viewValue: 'Upload - Servizio BEA Standard' });
        }
        if (this.pointsConfig[initialPointIdx].uploadBea && !this.isTraslocoUpload) {
            this.switchValues[index].splice(0, 0, { value: 'import_bea', viewValue: 'Upload - Servizio BEA Multisite' });
        }
        if (this.pointsConfig[initialPointIdx].id_building) {
            this.switchValues[index].splice(0, 0, { value: 'id_building', viewValue: 'ID Building' });
        }
        if (this.pointsConfig[initialPointIdx].city_noa) {
            this.switchValues[index].splice(0, 0, { value: 'city_noa', viewValue: 'Node List' });
        }
        if (this.env.controls.agf && this.pointsConfig[initialPointIdx].city_building) {
            this.switchValues[index].splice(0, 0, { value: 'city_building', viewValue: 'BI1G List' });
        }
        if (this.pointsConfig[initialPointIdx].id_bts_noa) {
            this.switchValues[index].splice(0, 0, { value: 'id_bts_noa', viewValue: 'Node Code' });
        }
        if (this.env.controls.agf && this.pointsConfig[initialPointIdx].id_bts_building) {
            this.switchValues[index].splice(0, 0, { value: 'id_bts_building', viewValue: 'BI1G Code' });
        }
        if (this.pointsConfig[initialPointIdx].id_school) {
            this.switchValues[index].splice(0, 0, { value: 'id_school', viewValue: 'ID Scuole' });
        }
        if (this.pointsConfig[initialPointIdx].id_healthcare) {
            this.switchValues[index].splice(0, 0, { value: 'id_healthcare', viewValue: 'ID Struttura Sanitaria' });
        }
        if (this.pointsConfig[initialPointIdx].coordinates) {
            this.switchValues[index].splice(0, 0, { value: 'coordinates', viewValue: 'Coordinates WGS84 (Google)' });
            this.switchValues[index].splice(0, 0, { value: 'coordinates_ed50', viewValue: 'Coordinates ED50' });
        }
        if (this.pointsConfig[initialPointIdx].pop && this.pointsConfig[initialPointIdx].poi) {
            this.switchValues[index].splice(0, 0, { value: 'poi', viewValue: 'Search Poi' });
            this.switchValues[index].splice(0, 0, { value: 'pop', viewValue: 'Search Pop' });
        }
        if (this.pointsConfig[initialPointIdx].address) {
            this.switchValues[index].splice(0, 0, { value: 'address', viewValue: 'Search Address' });
        }
        if (!this.pointsConfig[initialPointIdx].pop && this.pointsConfig[initialPointIdx].poi) {
            this.switchValues[index].splice(1, 0, { value: 'poi', viewValue: 'Search Poi' });
        }
        if (this.pointsConfig[initialPointIdx].pop && !this.pointsConfig[initialPointIdx].poi) {
            this.switchValues[index].splice(0, 0, { value: 'pop', viewValue: 'Search Pop' });
        }
        if (this.pointsConfig[initialPointIdx].pfs && !this.pointsConfig[initialPointIdx].punti_intermedi) { // PFS exist standalone in a landing and included in punti_intermedi in another
            this.switchValues[index].splice(0, 0, { value: 'pfs', viewValue: 'Search Pfs' });
        }
        if (this.pointsConfig[initialPointIdx].roe && !this.pointsConfig[initialPointIdx].punti_intermedi) { // ROE exist standalone in a landing and included in punti_intermedi in another
            this.switchValues[index].splice(0, 0, { value: 'roe', viewValue: 'Search Roe' });
        }
        if (this.pointsConfig[initialPointIdx].punti_intermedi) {
            this.switchValues[index].splice(0, 0, { value: 'punti_intermedi', viewValue: 'Type' });
        }

    }


    assignSwitchValue(index, value, force = false) {
        let end;
        let val = Utils.switchValues[value] ?? value;

        if (index !== null && index !== undefined) {
            end = index;
        } else if (this.selectedPoints[0] && this.selectedPoints[1] && !index) {
            end = null;
        } else {
            end = 0;
        }

        if (force) {
            end = index;
        }

        if (end !== null) {
            this.requestsType[end] = this.switchValues[end].filter(e => e.value === val)[0].value;
        } else {
            this.requestsType[end] = 'address';
        }
    }

    onSelectRpiType(event) {
        this.searchedType = { key: Utils.PUNTI_INTERMEDI_KEYS[event.point], value: event.point };
        if ((this.selectedPoints && this.selectedPoints.length) || (this.labels && this.labels.length)) {
            this.cities = [];
            this.labelsRpi = [];
            this.labels[0] = this.searchedType.value;
            this.selectedPoints[0] = {} as Point;
            this.map.removeMarkersByIndex(0);
        }
        this.landingPageService.getNetworkLinkPointsCities([this.searchedType.key], this.config.area_types_short).subscribe(res => {
            this.citiesRpi[this.searchedType.key] = res.results[this.searchedType.key];
        });
    }

    onSelectRpiComune(event) {
        if ((this.selectedPoints && this.selectedPoints.length) ||
            (this.labels && this.labels.length) || (this.labelsRpi && this.labelsRpi.length)) {
            this.labelsRpi = [];
            this.selectedPoints[0] = {} as Point;
            this.map.removeMarkersByIndex(0);
        }
        this.landingPageService.getNetworkLinkPoints([this.searchedType.key], this.config.area_types_short, event[0]).subscribe(res => {
            this.rpiList[this.searchedType.key] = res.results[this.searchedType.key];
            this.cities[0] = event[1]; // TODO when necessary manage multiple points. for now only one
            if (this.rpiList[this.searchedType.key] && this.rpiList[this.searchedType.key].length) {
                let coords = new google.maps.LatLng(this.rpiList[this.searchedType.key][0].coordinates);
                this.map?.map.setCenter(coords);
                this.map?.map.setZoom(10);
            }
        });
    }

    onSelectRpi(event) {
        this.setPoint(event, this.searchedType.key.toLowerCase(), false, 0, null, this.searchedType.key);
        this.labels[0] = this.searchedType.value;
    }


    loadWavelenghtCitiesPop(types: string[]) {
        if (types.includes('POP') && this.citiesPop && this.citiesPop.length) {
            types = types.filter(e => e !== 'POP');
        }
        if (types && types.length) {
            this.landingPageService.getWavelenghtCitiesPop().subscribe(res => {
                if (res.results) {
                    if (res.results) {
                        this.citiesPop = res.results;
                    }
                }
            })
        }
    }

    loadWavelenghtCitiesPoi(types: string[]) {
        if (types.includes('POI') && this.citiesPoi && this.citiesPoi.length) {
            types = types.filter(e => e !== 'POI');
        }
        if (types && types.length) {
            this.landingPageService.getWavelenghtCitiesPoi(this.user.olocode).subscribe(res => {
                if (res.results) {
                    if (res.results) {
                        this.citiesPoi = res.results;
                    }
                }
            })
        }
    }

    onSelectPopComune(event, index, type) {

        if (!event) {
            return;
        }

        // event = [city_id, city_name]

        this.wavelengthLists[index][type] = [];
        this.wavelengthList[type] = [];

        if (event && event[0]) {
            this.landingPageService.getPopWavelenghtList(event[0]).subscribe(res => {
                if (res) {
                    const filteredList = res.filter(obj => {
                        if (!this.config.pop_agf.load && obj.type.toLowerCase() === "agf") {
                            return false
                        }

                        return true
                    })
                    this.wavelengthLists[index][type] = filteredList
                    this.wavelengthList[type] = filteredList

                    if (this.wavelengthLists[index][type] && this.wavelengthLists[index][type].length) {
                        this.map?.map.setCenter(this.wavelengthLists[index][type][0])
                        this.map?.map.setZoom(type === 'POP' ? 10 : 12)
                    }
                }
            })
        }

        this.additionalAutocompletes[index] = true;
        this.labels[index] = ''

        if (event && event[1]) {
            this.cityLabelPop[index] = event[1]
        }

        this.cdr.detectChanges()
        this.blurInputElements()
    }

    onSelectPoiComune(event, index, type) {
        if (!event) {
            return;
        }

        // event = [city_id, city_name]
        // TODO RIORGANIZZA


        if (event && event[0]) {
            this.wavelengthLists[index][type] = [];
            this.wavelengthList[type] = [];

            this.landingPageService.getPoiWavelenghtList(event[0], this.user.olocode).subscribe(res => {
                if (res) {
                    this.wavelengthLists[index][type] = res;
                    this.wavelengthList[type] = res;
                    if (this.wavelengthLists[index][type] && this.wavelengthLists[index][type].length) {
                        this.map?.map.setCenter(this.wavelengthLists[index][type][0].coordinates);
                        this.map?.map.setZoom(type === 'POI' ? 10 : 12);
                    }
                }
            });
        }

        this.additionalAutocompletes[index] = true;
        this.labels[index] = ''

        if (event && event[1]) {
            this.cityLabelPoi[index] = event[1]
        }

        this.cdr.detectChanges()
        this.blurInputElements()
    }


    onSelectWavelength(event) {
        this.setPoint(event, this.searchedType.key.toLowerCase(), false, 0, null, this.searchedType.key);
        this.labels[0] = this.searchedType.value;
    }

    onComuneSelected(event, index, type) {
        // event = [city_id, city_name]

        this.landingPageService.getBtsList(event[0], [type]).subscribe(res => {
            if (res) {
                this.btsLists[index][type] = res.results?.[type];
                this.btsList[type] = res.results?.[type];

                if (this.btsLists[index][type] && this.btsLists[index][type].length) {
                    this.map?.map.setCenter(this.btsLists[index][type][0].coordinates);
                    this.map?.map.setZoom(type === 'NOA' ? 10 : 12);
                }
            }
        });

        this.additionalAutocompletes[index] = true;
        this.cities[index] = event[1];

        if (index === 0) {
            this.canAddPointsOptional();
        }

        this.cdr.detectChanges()
    }

    onFilteredList(filteredList, mapList) {
        mapList = filteredList;
        this.map?.map.setCenter(filteredList[0].coordinates);
        this.map?.map.setZoom(12);
    }

    private setPointDynamicAend(point: any, end: any): { long_provincia: string, comune: string } {

        if (point.indirizzo && point.indirizzo.comune && point.indirizzo.provincia) {
            this.actualPoint = {
                long_provincia: point.indirizzo.provincia,
                comune: point.indirizzo.comune,
                end
            }
        } else if (point.address_components && point.address_components.length) {
            this.actualPoint = {
                long_provincia: this.helpersService.getInfoSmall(point.address_components, ['administrative_area_level_2'], 'short_name'),
                comune: this.helpersService.retComune(point.address_components),
                end
            }
        } else {
            if (point.coordinates && this.geocoderResults) {
                let latLng = this.setCoordinates(point);

                if (this.geocoderResults.results && this.geocoderResults.results.length) {
                    const country = this.geocoderResults.results[0].address_components.filter(x => x.types.includes('country'));
                    this.isOutsideItaly = country && country.length ? country[0].short_name !== 'IT' : true;

                }
                if (this.geocoderResults.status == google.maps.GeocoderStatus.OK) {
                    this.actualPoint = this.helpersService.pointInfoToDynamicAend(this.geocoderResults.results, end);
                    this.canAddPointsOptional();

                }

                this.geocoderResults = null;

                /*
                this.geocoder.geocode({ location: latLng, 'region': 'it' }, (results, status) => {
                  if (results && results.length) {
                    const country = results[0].address_components.filter(x => x.types.includes('country'));
                    this.isOutsideItaly = country && country.length ? country[0].short_name !== 'IT' : true;
                  }
                  if (status == google.maps.GeocoderStatus.OK) {
                    this.actualPoint = this.helpersService.pointInfoToDynamicAend(results, end);
                    this.canAddPointsOptional();
                  }
                });*/

            }
        }

        return this.actualPoint;
    }


    setPoint(point, type, isTemp, end, defaultLabel?, researchMethod = "POINT") {

        this.setPointDynamicAend(point, end)
        this.canAddPointsOptional(isTemp)

        let p: Point = new Point()
        p.end = end
        p.address_components = point.address_components ? point.address_components : []
        p.id = point.id ? point.id : null
        p.indirizzo = point.indirizzo
        if (type === "address" || type === "coordinates" || type === "building" || type === "noa") {
            this.checkPointEnd = end // TODO aggiungere bts quando verranno aggiunti altri input
        }

        switch (type.toLowerCase()) {
            case "address":
                p.visible_label = point.formatted_address
                p.address = point.formatted_address
                p.label = point.formatted_address
                p.type = "Point"
                p.research_method = Utils.RESEARCH_METHODS[researchMethod.toLowerCase()]
                p.coordinates = this.setCoordinates(point)
                // p.comune = this.helpersService.retComune(point.address_components);
                p.comune = this.helpersService.getInfoSmall(point.address_components, ["administrative_area_level_3"])
                // p.provincia = this.helpersService.getInfoSmall(point.address_components, ['administrative_area_level_2'], 'short_name');
                p.cap = this.helpersService.getInfoSmall(point.address_components, ["postal_code"])
                p.provincia = this.helpersService.getInfoSmall(
                    point.address_components,
                    ["administrative_area_level_2"],
                    "short_name"
                )
                p.country = this.helpersService.getInfoSmall(point.address_components, ["country"], "short_name")
                p.street_number = this.helpersService.getInfoSmall(point.address_components, ["street_number"])
                p.street = this.helpersService.getInfoSmall(point.address_components, ["route", "town_square"])
                break
            case "coordinates":
                p.visible_label = defaultLabel ? defaultLabel : point.formatted_address
                p.address = point.formatted_address
                p.label = defaultLabel ? defaultLabel : point.formatted_address
                p.type = "Point"
                p.research_method = Utils.RESEARCH_METHODS[researchMethod.toLowerCase()]
                p.coordinates = this.setCoordinates(point)
                // p.comune = point.comune ? point.comune : point.address_components ? this.helpersService.retComune(point.address_components) : null;
                // p.street = point.street ? point.street : point.address_components ? this.helpersService.getInfoSmall(point.address_components, ['route', 'town_square']) : null;
                // p.street_number = point.street_number ? point.street_number : point.address_components ? this.helpersService.getInfoSmall(point.address_components, ['street_number']) : null;
                // p.cap = point.cap ? point.cap : point.address_components ? this.helpersService.getInfoSmall(point.address_components, ['postal_code']) : null;
                // p.provincia = point.provincia ? point.provincia : point.address_components ? this.helpersService.getInfoSmall(point.address_components, ['administrative_area_level_2'], 'short_name') : null;
                p.comune = point.comune
                    ? point.comune
                    : point.address_components
                        ? this.helpersService.getInfoSmall(point.address_components, ["administrative_area_level_3"])
                        : this.actualPoint
                            ? this.actualPoint.comune
                            : null
                p.street = point.street
                    ? point.street
                    : point.address_components
                        ? this.helpersService.getInfoSmall(point.address_components, ["route", "town_square"])
                        : null
                p.street_number = point.street_number
                    ? point.street_number
                    : point.address_components
                        ? this.helpersService.getInfoSmall(point.address_components, ["street_number"])
                        : null
                p.cap = point.cap
                    ? point.cap
                    : point.address_components
                        ? this.helpersService.getInfoSmall(point.address_components, ["postal_code"])
                        : null
                p.provincia = point.provincia
                    ? point.provincia
                    : point.address_components
                        ? this.helpersService.getInfoSmall(
                            point.address_components,
                            ["administrative_area_level_2"],
                            "short_name"
                        )
                        : this.actualPoint
                            ? this.actualPoint.long_provincia
                            : null
                break
            case "building":
                p.visible_label = defaultLabel ? defaultLabel : point.building_labels[0]
                p.address = point.building_labels[0]
                p.label = point.id_building ? point.id_building : point.id
                p.type = "Building"
                p.research_method = Utils.RESEARCH_METHODS[researchMethod.toLowerCase()]
                p.coordinates = { lat: point.coordinates.coordinates[1], lng: point.coordinates.coordinates[0] }
                p.comune = point.indirizzo && point.indirizzo?.comune ? point.indirizzo.comune : null
                p.street =
                    point.indirizzo && point.indirizzo.particella_top && point.indirizzo.via
                        ? point.indirizzo.particella_top + " " + point.indirizzo.via
                        : null
                p.street_number = point.indirizzo && point.indirizzo.civico ? point.indirizzo.civico : null
                p.cap = point.cap ? point.cap : null
                p.provincia = point.provincia ? point.provincia : null
                break
            case "bts_noa":
                p.visible_label = "#" + point.id
                p.address = null
                p.label = "#" + point.id
                p.type = "BTS_NOA"
                p.id = point.id
                p.research_method = Utils.RESEARCH_METHODS[researchMethod.toLowerCase()]
                p.coordinates = { lat: point.coordinates.lat, lng: point.coordinates.lng }
                break
            case "bts_building":
                p.visible_label = point.id
                p.address = null
                p.label = defaultLabel ? defaultLabel : point.id
                p.type = "BTS_BUILDING"
                p.id = point.id
                p.research_method = Utils.RESEARCH_METHODS[researchMethod.toLowerCase()]
                p.coordinates = { lat: point.coordinates.lat, lng: point.coordinates.lng }
                break
            case "noa":
                p.visible_label = "#" + point.id
                p.address = null
                p.label = "#" + point.id
                p.type = "Noa"
                p.id = point.id
                p.research_method = Utils.RESEARCH_METHODS[researchMethod.toLowerCase()]
                p.coordinates = {
                    lat: point.coordinates.coordinates ? point.coordinates.coordinates[1] : point.coordinates.lat,
                    lng: point.coordinates.coordinates ? point.coordinates.coordinates[0] : point.coordinates.lng
                }
                p.comune = point.comune ? point.comune : null
                break
            case "school":
                p.visible_label = point.building ? point.building.school_code : point.school_code
                p.address = null
                p.label = point.building ? point.building.school_name : point.school_name
                p.type = "school"
                p.id = point.building ? point.building.id : point.id
                p.research_method = Utils.RESEARCH_METHODS[researchMethod.toLowerCase()]
                p.coordinates = this.setCoordinates(point)
                p.comune = point.building ? point.building.comune : point.comune ? point.comune : null
                break
            case "healthcare":
                p.visible_label = point.building ? point.building.healthcare_code : point.healthcare_code
                p.address = null
                p.label = point.building ? point.building.healthcare_name : point.healthcare_name
                p.type = "healthcare"
                p.id = point.building ? point.building.id : point.id
                p.research_method = Utils.RESEARCH_METHODS[researchMethod.toLowerCase()]
                p.coordinates = this.setCoordinates(point)
                p.comune = point.building ? point.building.comune : point.comune ? point.comune : null
                break
            case "poi":
                p.visible_label = point.fullname ? point.fullname : point.address
                p.address = point.address
                p.label = point.address
                p.type = "Poi"
                p.research_method =
                    this.config.poi.custom_research_method !== null
                        ? this.config.poi.custom_research_method
                        : Utils.RESEARCH_METHODS[researchMethod.toLowerCase()]
                p.coordinates = { lat: point.coordinates.lat, lng: point.coordinates.lng }
                p.comune = point.comune_name ? point.comune_name : null
                break
            case "pop":
                p.visible_label = point.nome
                p.address = point.nome
                p.label = point.nome
                p.type = "POP"
                p.research_method = Utils.RESEARCH_METHODS[researchMethod.toLowerCase()]
                p.coordinates = { lat: point.lat, lng: point.lng }
                p.comune = point.comune ? point.comune : null
                break
            case "pfs":
                p.visible_label = point.code
                p.address = point.code
                p.label = point.code
                p.type = "PFS"
                p.research_method = Utils.RESEARCH_METHODS[researchMethod.toLowerCase()]
                p.coordinates = { lat: point.coordinates.lat, lng: point.coordinates.lng }
                p.comune = point.comune ? point.comune : null
                break
            case "roe":
                p.visible_label = point.code
                p.address = point.code
                p.label = point.code
                p.type = "ROE"
                p.research_method = Utils.RESEARCH_METHODS[researchMethod.toLowerCase()]
                p.coordinates = { lat: point.coordinates.lat, lng: point.coordinates.lng }
                p.comune = point.comune ? point.comune : null
                break
            case "cno":
                p.visible_label = point.code
                p.address = point.code
                p.label = point.code
                p.type = "CNO"
                p.research_method = Utils.RESEARCH_METHODS[researchMethod.toLowerCase()]
                p.coordinates = { lat: point.coordinates.lat, lng: point.coordinates.lng }
                p.comune = point.comune ? point.comune : null
                break
            case "pozzetto":
                p.visible_label = point.code
                p.address = point.code
                p.label = point.code
                p.type = "POZZETTO"
                p.research_method = Utils.RESEARCH_METHODS[researchMethod.toLowerCase()]
                p.coordinates = { lat: point.coordinates.lat, lng: point.coordinates.lng }
                p.comune = point.comune ? point.comune : null
                break
            default:
                p.visible_label = point.formatted_address
                p.address = point.formatted_address
                p.label = point.formatted_address
                p.type = type
                p.research_method = Utils.RESEARCH_METHODS["address"]
                p.coordinates = this.setCoordinates(point)
                // p.comune = this.helpersService.retComune(point.address_components);
                p.comune = this.helpersService.getInfoSmall(point.address_components, ["administrative_area_level_3"])
                p.cap = this.helpersService.getInfoSmall(point.address_components, ["postal_code"])
                p.provincia = this.helpersService.getInfoSmall(
                    point.address_components,
                    ["administrative_area_level_2"],
                    "short_name"
                )
                p.country = this.helpersService.getInfoSmall(point.address_components, ["country"], "short_name")
                p.street_number = this.helpersService.getInfoSmall(point.address_components, ["street_number"])
                p.street = this.helpersService.getInfoSmall(point.address_components, ["route", "town_square"])
                break
        }

        p.isTemp = isTemp

        if (!isTemp) {
            this.map.removeMarkersTemp()

            const cityLabelPoi = this.cityLabelPoi[end] || ""
            const cityLabelPop = this.cityLabelPop[end] || ""
            const poiLabel = this.poiLabels[end] || ""
            const popLabel = this.popLabels[end] || ""
            const poiByCityLabel = this.poiByCityLabels[end] || ""
            const popByCityLabel = this.popByCityLabels[end] || ""

            if (type.toLowerCase() === "poi") {
                this.cityLabelPoi[end] = cityLabelPoi
                this.poiLabels[end] = poiLabel
                this.poiByCityLabels[end] = poiByCityLabel
            }
            if (type.toLowerCase() === "pop") {
                this.cityLabelPop[end] = cityLabelPop
                this.popLabels[end] = popLabel
                this.popByCityLabels[end] = popByCityLabel
            }

            if (!this.requestsTypeRpi[end] || !this.pointsConfig.b_end.punti_intermedi) {
                this.labels[end] = p.visible_label
            } else {
                this.labelsRpi[end] = p.visible_label
            }
            if (!this.requestsTypeWavelength[end] || !this.pointsConfig.b_end.pop_pcn_xpop) {
                this.labels[end] = p.visible_label
            } else {
                this.labelsWavelength[end] = p.visible_label
            }

            this.selectedPoints[end] = p


            this.canAddPointsOptional()
            //nel caso necessiti di marker numerati
            this.map.showMarker(p, (this.RequiresNumberedMakers.includes(this.config.data.service_slug)) ? end : undefined)


        } else if (isTemp) {
            this.tempPoint = p
            this.tempPoint.label = p.visible_label
            this.map.showTempMarker(p)
        }
    }

    private setCoordinates(point: any): any {
        let lat: number;
        let lng: number;

        if (point.coordinates?.coordinates) {
            [lng, lat] = point.coordinates.coordinates;
        } else if (point.coordinates?.lat && point.coordinates?.lng) {
            lat = typeof point.coordinates.lat === 'function' ? point.coordinates.lat() : point.coordinates.lat;
            lng = typeof point.coordinates.lng === 'function' ? point.coordinates.lng() : point.coordinates.lng;
        } else if (point.building?.coordinates?.coordinates) {
            [lng, lat] = point.building.coordinates.coordinates;
        } else if (point.building?.coordinates) {
            lat = point.building.coordinates.lat;
            lng = point.building.coordinates.lng;
        } else if (point.geometry?.location?.lat && point.geometry?.location?.lng) {
            lat = typeof point.geometry.location.lat === 'function' ? point.geometry.location.lat() : point.geometry.location.lat;
            lng = typeof point.geometry.location.lng === 'function' ? point.geometry.location.lng() : point.geometry.location.lng;
        }

        if (lat === undefined || lng === undefined) {
            throw new Error('Invalid point object: unable to extract coordinates');
        }

        return { lat, lng };
    }

    private checkIfBuilding(point, end, lat?, lng?, type?, research_method?) {
        this.modalBuildings = [];
        this.modalEnd = end;
        this.wait = true;
        const placeLat = lat ? lat : this.setCoordinates(point).lat;
        const placeLng = lng ? lng : this.setCoordinates(point).lng;
        this.landingPageService.getBuildingByCoordinates(placeLat, placeLng).subscribe(res => {
            const buildings = res.results;
            if (buildings && buildings.length) {
                let method = this.requestsType[end ? end : 0] == 'coordinates' ? 'COORDINATES' : 'ADDRESS';
                if (buildings.length > 1) {
                    if (point.address_components) {
                        const searchedBuilding = point.address_components.filter(a => a.types.includes('street_number'))[0].short_name;
                        const found = buildings.filter(b => b.indirizzo && b.indirizzo.civico && b.indirizzo.civico === searchedBuilding);
                        if (found && found.length && found.length > 1) {
                            const foundFtth = found.filter(e => e.tipologia_building === 'FTTH')[0];
                            const foundMan = found.filter(e => e.tipologia_building === 'MAN')[0];
                            const foundToUse = foundFtth ? foundFtth : foundMan;
                            if (this.isTrasloco) {
                                this.setPoint(foundToUse, 'building', false, this.endEditablePoint, point.address, method);
                            } else {
                                this.setPoint(foundToUse, 'building', false, 0, point.address, method);
                            }
                            if (foundToUse.indirizzo && foundToUse.indirizzo.id) {
                                this.assignSwitchValue(end, 'address')
                            } else {
                                this.assignSwitchValue(end, 'building')
                            }
                        } else if (found && found.length && found.length === 1) {
                            if (this.isTrasloco) {
                                this.setPoint(found[0], 'building', false, this.endEditablePoint, point.address, method);
                            } else {
                                this.setPoint(found[0], 'building', false, end, point.address, method);
                            }
                            if (found[0].indirizzo && found[0].indirizzo.id) {
                                this.assignSwitchValue(end, 'address')
                            } else {
                                this.assignSwitchValue(end, 'building')
                            }
                        } else {
                            this.modalBuildings = res.results;
                            this.zone.run(() => {
                                this.modalMultiBuilding.open(this.modalBuildings);
                            })
                        }
                    } else {
                        this.modalBuildings = res.results;
                        this.zone.run(() => {
                            this.modalMultiBuilding.open(this.modalBuildings);
                        })
                    }
                    this.wait = false;
                } else {
                    this.pointFromModal = true;
                    switch (method) {
                        case 'ADDRESS':
                            this.requestsType[end] = 'address';
                            break;
                        case 'COORDINATES':
                            this.requestsType[end] = 'coordinates';
                            break;
                        default:
                            this.requestsType[end] = 'id_building';
                            break;
                    }
                    if (this.config.multiple_points.max > 1) {
                        const isTemp = end !== null ? false : true;
                        this.setPoint(buildings[0], 'building', isTemp, end, point.address, method);
                        if (buildings[0].indirizzo && buildings[0].indirizzo.id) {
                            this.assignSwitchValue(end, 'address')
                        } else {
                            this.assignSwitchValue(end, 'building')
                        }
                        this.showToast = end !== null ? false : true;
                    } else {
                        this.setPoint(buildings[0], 'building', false, 0, point.address, method);
                        if (buildings[0].indirizzo && buildings[0].indirizzo.id) {
                            this.assignSwitchValue(end, 'address')
                        } else {
                            this.assignSwitchValue(end, 'building')
                        }
                    }
                    this.helpersService.close('multiBuildingModal');
                    this.wait = false;
                }
            } else {
                const typeTemp = point && point.address_components ? 'address' : 'coordinates';
                this.geocoder.geocode({ location: point.coordinates, 'region': 'it' }, (results) => {
                    if (results && results.length) {
                        let p1: any = results[0];
                        const country = p1.address_components.filter(x => x.types.includes('country'));
                        this.isOutsideItaly = country && country.length ? country[0].short_name !== 'IT' : true;
                        p1.coordinates = point.coordinates;
                        if (p1) {
                            this.setPoint(p1, typeTemp, false, end, point.formatted_address, 'Coordinates');
                        }
                    } else {
                        this.setPoint(point, typeTemp, false, end);
                    }
                });
                this.wait = false;
            }
        });
    }

    private checkIfBuildingSchool(point, end) {
        this.modalScuoleSanita = [];
        this.modalEnd = end;
        this.wait = true;
        const placeLat = String(this.setCoordinates(point).lat);
        const placeLng = String(this.setCoordinates(point).lng);
        if (this.isEnabledOnThisInput(end ? end : 0, 'id_school')) {
            this.landingPageService.getSchoolsByCoordinates(placeLat, placeLng).subscribe(schoolByCoordinate => {
                const buildings = schoolByCoordinate.results;
                if (buildings && buildings.length) {
                    this.isAnnoBandoDropdownVisible = false;
                    if (buildings.length > 1) {
                        this.modalScuoleSanita = schoolByCoordinate.results;
                        this.zone.run(() => {
                            this.modalComponentSS.open(this.modalScuoleSanita, 'school');
                        })
                        this.wait = false;
                    } else {
                        this.pointFromModal = true;
                        let method = this.requestsType[end ? end : 0] == 'coordinates' ? 'COORDINATES' : 'ADDRESS';
                        if (this.config.multiple_points.max > 1) {
                            const isTemp = end !== null ? false : true;
                            this.setPoint(buildings[0], 'school', isTemp, end, point.address, method);
                            this.requestsType[end] = 'address';
                            this.showToast = end !== null ? false : true;
                        } else {
                            this.setPoint(buildings[0], 'school', false, 0, point.address, method);
                            this.requestsType[end] = 'address';
                        }
                        switch (method) {
                            case 'ADDRESS':
                                this.requestsType[end] = 'address';
                                break;
                            case 'COORDINATES':
                                this.requestsType[end] = 'coordinates';
                                break;
                            default:
                                this.requestsType[end] = 'id_school';
                                break;
                        }
                        this.helpersService.close('modalComponentSS');
                        this.wait = false;
                    }
                } else {
                    if (this.annoBandoRequired) {
                        this.menageAnnoBandoOptions(point)
                    }
                    this.isAnnoBandoDropdownVisible = true;
                    this.setPoint(point, 'address', false, 0, point.address, 'ADDRESS');
                    this.requestsType[end] = 'address';
                    this.wait = false;
                }
            });
        } else {
            this.checkIfBuilding(point, end, placeLat, placeLng);
            this.wait = false;
        }
    }

    private checkIfBts(point, end) {
        this.modalPoints = [];
        this.modalEnd = end;
        this.wait = true;
        const placeLat = String(this.setCoordinates(point).lat);
        const placeLng = String(this.setCoordinates(point).lng);
        let types = [];
        if (this.isEnabledOnThisInput(end ? end : 0, 'id_bts_noa')) {
            types.push('NOA');
        }
        if (this.isEnabledOnThisInput(end ? end : 0, 'id_bts_building')) {
            types.push('BUILDING');
        }
        if (types.length) {
            this.landingPageService.getBtsByCoordinates(placeLat, placeLng, types).subscribe(res => {
                if (res && res.results) {
                    // se c'è un solo elemento
                    if (res.results.BUILDING && res.results.BUILDING.length === 1 && (!res.results.NOA || !res.results.NOA.length)) {
                        this.map?.map.setCenter(res.results.BUILDING[0].coordinates);
                        this.map?.map.setZoom(10);
                        this.storeBts('BTS_BUILDING', res.results.BUILDING[0], res.results.BUILDING[0].points[res.results.BUILDING[0].code], end);
                        this.assignSwitchValue(end, 'bts_building')
                    } else if (res.results.NOA && res.results.NOA.length === 1 && (!res.results.BUILDING || !res.results.BUILDING.length)) {
                        this.map?.map.setCenter(res.results.NOA[0].coordinates);
                        this.map?.map.setZoom(10);
                        this.storeBts('BTS_NOA', res.results.NOA[0], null, end);
                        this.assignSwitchValue(end, 'bts_noa')
                    }
                    // // se c'è più di un elemento
                    else if ((res.results.BUILDING && res.results.BUILDING.length > 1) || (res.results.NOA && res.results.NOA.length > 1) || (res.results.BUILDING && res.results.NOA && res.results.BUILDING.length >= 1 && res.results.NOA.length >= 1)) {
                        this.modalPoints = res.results;
                        this.modalEnd = end;
                        this.zone.run(() => {
                            this.modalMultiPoints.open(this.modalPoints);
                        })
                    } else {
                        const typeTemp = point && point.address_components ? 'address' : 'coordinates';
                        this.geocoder.geocode({ location: point.coordinates, 'region': 'it' }, (results) => {
                            if (results && results.length) {
                                let p1: any = results[0];
                                const country = p1.address_components.filter(x => x.types.includes('country'));
                                this.isOutsideItaly = country && country.length ? country[0].short_name !== 'IT' : true;
                                p1.coordinates = point.coordinates;
                                if (p1) {
                                    this.setPoint(p1, typeTemp, false, end, point.formatted_address, 'Coordinates');
                                }
                            } else {
                                this.setPoint(point, typeTemp, false, end);
                            }
                        });
                        this.wait = false;
                    }
                }
            });
        } else {
            this.checkIfBuilding(point, end, placeLat, placeLng);
            this.wait = false;
        }
    }

    private checkIfHealthcare(point, end) {
        this.modalPoints = [];
        this.modalEnd = end;
        this.wait = true;
        const placeLat = String(this.setCoordinates(point).lat);
        const placeLng = String(this.setCoordinates(point).lng);
        if (this.isEnabledOnThisInput(end ? end : 0, 'id_healthcare')) {
            this.landingPageService.getHealthcareByCoordinates(placeLat, placeLng).subscribe(healthcareByCoordinate => {
                const buildings = healthcareByCoordinate.results;
                if (buildings && buildings.length) {
                    this.isAnnoBandoDropdownVisible = false;
                    if (buildings.length > 1) {
                        this.modalScuoleSanita = healthcareByCoordinate.results;
                        this.zone.run(() => {
                            this.modalComponentSS.open(this.modalScuoleSanita, 'healthcare');
                        })
                        this.wait = false;
                    } else {
                        this.pointFromModal = true;
                        let method = this.requestsType[end ? end : 0] == 'coordinates' ? 'COORDINATES' : 'ADDRESS';
                        if (this.config.multiple_points.max > 1) {
                            const isTemp = end !== null ? false : true;
                            this.setPoint(buildings[0], 'healthcare', isTemp, end, point.address, method);
                            this.requestsType[end] = 'address';
                            this.showToast = end !== null ? false : true;
                        } else {
                            this.setPoint(point, 'healthcare', false, 0, point.address, method);
                            this.requestsType[end] = 'address';
                        }
                        switch (method) {
                            case 'ADDRESS':
                                this.requestsType[end] = 'address';
                                break;
                            case 'COORDINATES':
                                this.requestsType[end] = 'coordinates';
                                break;
                            default:
                                this.requestsType[end] = 'id_healthcare';
                                break;
                        }
                        this.helpersService.close('modalComponentSS');
                        this.wait = false;
                    }
                } else {
                    if (this.annoBandoRequired) {
                        this.menageAnnoBandoOptions(point)
                    }
                    this.isAnnoBandoDropdownVisible = true;
                    this.setPoint(point, 'address', false, 0, point.address, 'ADDRESS');
                    this.requestsType[end] = 'address';
                    this.wait = false;
                }
            });
        } else {
            this.checkIfBuilding(point, end, placeLat, placeLng);
            this.wait = false;
        }
    }

    public onDismissModalMultiBuilding(index) {
        this.map.removeMarkersByIndex(index);
        if (this.selectedPoints.length >= index) {
            this.selectedPoints[index] = null;
            this.map.selectedPoints[index] = null;
            this.labels[index] = '';
            if (this.coordinatesSearch && this.coordinatesSearch.filter((e, i) => i === index)[0]) {
                this.coordinatesSearch.filter((e, i) => i === index)[0].reset();
            }
        }
        this.helpersService.close('multiBuildingModal');
        this.helpersService.close('multiPointsModal');
        this.helpersService.close('modalComponentSS');
    }

    public onPlaceChanged(idx, type?) {
        const index = idx ? idx : 0;
        this.selectedPoints[index] = null;
        if (type) {
            this.resetPoint(type, index);
        }
    }

    public onClickBuilding(event) {
        this.pointFromModal = true;
        this.requestsType[event.end] = 'address';
        this.onSelectBuilding(event.building, event.end, false, 'address', event.building.building_labels[0]);
        this.setPointDynamicAend(event.building, event.end);
        this.canAddPointsOptional();
    }

    public onSelectBuilding(building, end, checkIfMultiple = true, requestType = 'id_building', visibleLabel?) {
        this.modalBuildings = [];
        this.wait = true;
        if (checkIfMultiple) {
            this.landingPageService.getBuildingByCoordinates(building.coordinates.coordinates[1], building.coordinates.coordinates[0]).subscribe(res => {
                if (res.results.length > 1) {
                    this.modalBuildings = res.results;
                    this.modalEnd = this.config.multiple_points.max > 1 && this.selectedPoints.length > 1 ? end : null;
                    this.zone.run(() => {
                        this.modalMultiBuilding.open(this.modalBuildings);
                    })
                    this.wait = false;
                } else {
                    if (this.config.multiple_points.max > 1 && this.selectedPoints.length > 1) {
                        if (this.isTrasloco) {
                            this.setPoint(building, 'building', false, this.endEditablePoint, building.address, 'BUILDING');
                        } else {
                            const isTemp = end !== null ? false : true;
                            this.setPoint(building, 'building', isTemp, end, building.address, 'BUILDING');
                        }
                        if (building.indirizzo && building.indirizzo.id) {
                            this.assignSwitchValue(end, 'address')
                        } else {
                            this.assignSwitchValue(end, 'building')
                        }
                        if (!this.isTrasloco) {
                            this.showToast = end !== null ? false : true;
                        }
                    } else {
                        if (this.isTrasloco) {
                            this.setPoint(building, 'building', false, this.endEditablePoint, building.address, 'BUILDING');
                        } else {
                            this.setPoint(building, 'building', false, 0, building.address, 'BUILDING');
                        }
                        if (building.indirizzo && building.indirizzo.id) {
                            this.assignSwitchValue(end, 'address')
                        } else {
                            this.assignSwitchValue(end, 'building')
                        }
                    }
                    this.helpersService.close('multiBuildingModal');
                    this.modalEnd = null;
                    this.wait = false;
                }
            });
        } else {
            const buildingLabel = visibleLabel ? visibleLabel : (building.id_building ? building.id_building : building.id);
            if (this.config.multiple_points.max > 1 && this.selectedPoints.length > 1) {
                if (this.isTrasloco) {
                    this.setPoint(building, 'building', false, this.endEditablePoint, building.address, 'ADDRESS');
                } else {
                    const isTemp = end !== null ? false : true;
                    this.setPoint(building, 'building', isTemp, end, buildingLabel, 'ADDRESS');
                }
                if (building.indirizzo && building.indirizzo.id) {
                    this.assignSwitchValue(end, 'address')
                } else {
                    this.assignSwitchValue(end, 'building')
                }
                if (!this.isTrasloco) {
                    this.showToast = end !== null ? false : true;
                }
            } else {
                if (this.isTrasloco) {
                    this.setPoint(building, 'building', false, this.endEditablePoint, building.address, 'ADDRESS');
                } else {
                    this.setPoint(building, 'building', false, end !== null ? end : 0, buildingLabel, 'ADDRESS');
                }
                if (building.indirizzo && building.indirizzo.id) {
                    this.assignSwitchValue(end, 'address')
                } else {
                    this.assignSwitchValue(end, 'building')
                }
            }
            this.helpersService.close('multiBuildingModal');
            this.modalEnd = null;
            this.wait = false;
        }
    }

    public onSelectSchool(building, end, checkIfMultiple = true, requestType = 'id_school', visibleLabel?) {
        this.modalScuoleSanita = [];
        this.wait = true;
        let buildingCoord = this.setCoordinates(building);
        if (checkIfMultiple) {
            this.landingPageService.getSchoolsByCoordinates(buildingCoord.lat, buildingCoord.lng).subscribe(res => {
                if (res.results.length > 1) {
                    this.modalScuoleSanita = res.results;
                    this.modalEnd = this.config.multiple_points.max > 1 && this.selectedPoints.length > 1 ? end : null;
                    this.zone.run(() => {
                        this.modalComponentSS.open(this.modalScuoleSanita, 'school');
                    })
                    this.wait = false;
                } else {
                    if (this.config.multiple_points.max > 1 && this.selectedPoints.length > 1) {
                        if (this.isTrasloco) {
                            this.setPoint(building, 'school', false, this.endEditablePoint, building.school_code, 'BUILDING');
                        } else {
                            const isTemp = end !== null ? false : true;
                            this.setPoint(building, 'school', isTemp, end, building.school_code, 'BUILDING');
                            this.requestsType[end] = requestType;
                            this.showToast = end !== null ? false : true;
                        }
                    } else {
                        this.setPoint(building, 'school', false, 0, building.school_code, 'BUILDING');
                        this.requestsType[0] = requestType;
                    }
                    this.helpersService.close('modalComponentSS');
                    this.modalEnd = null;
                    this.wait = false;
                }
            });
        } else {
            const buildingLabel = visibleLabel ? visibleLabel : building.school_code;
            if (this.config.multiple_points.max > 1 && this.selectedPoints.length > 1) {
                if (this.isTrasloco) {
                    this.setPoint(building, 'school', false, this.endEditablePoint, buildingLabel, 'ADDRESS');
                } else {
                    const isTemp = end !== null ? false : true;
                    this.setPoint(building, 'school', isTemp, end, buildingLabel, 'ADDRESS');
                    this.showToast = end !== null ? false : true;
                }
            } else {
                this.setPoint(building, 'school', false, 0, buildingLabel, 'ADDRESS');
                this.requestsType[0] = requestType;
            }
            this.helpersService.close('modalComponentSS');
            this.modalEnd = null;
            this.wait = false;
        }
    }

    public onSelectHealtcare(building, end, checkIfMultiple = true, requestType = 'id_healthcare', visibleLabel?) {

        this.modalScuoleSanita = [];
        this.wait = true;
        let buildingCoord = this.setCoordinates(building);
        if (checkIfMultiple) {
            this.landingPageService.getHealthcareByCoordinates(buildingCoord.lat, buildingCoord.lng).subscribe(res => {
                if (res.results.length > 1) {
                    this.modalScuoleSanita = res.results;
                    this.modalEnd = this.config.multiple_points.max > 1 && this.selectedPoints.length > 1 ? end : null;
                    this.zone.run(() => {
                        this.modalComponentSS.open(this.modalScuoleSanita, 'healthcare');
                    })
                    this.wait = false;
                } else {
                    if (this.config.multiple_points.max > 1 && this.selectedPoints.length > 1) {
                        if (this.isTrasloco) {
                            this.setPoint(building, 'healthcare', false, this.endEditablePoint, building.healthcare_code, 'BUILDING');

                        } else {
                            end = this.selectRightEndForToast();
                            const isTemp = end !== null ? false : true;
                            this.setPoint(building, 'healthcare', isTemp, end, building.healthcare_code, 'BUILDING');
                            this.requestsType[end] = requestType;
                            this.showToast = end !== null ? false : true;
                        }
                    } else {
                        this.setPoint(building, 'healthcare', false, 0, building.healthcare_code, 'BUILDING');
                        this.requestsType[0] = requestType;
                    }
                    this.helpersService.close('modalComponentSS');
                    this.modalEnd = null;
                    this.wait = false;
                }
            });
        } else {
            const buildingLabel = visibleLabel ? visibleLabel : building.healthcare_code;
            if (this.config.multiple_points.max > 1 && this.selectedPoints.length > 1) {
                const isTemp = end !== null ? false : true;
                this.setPoint(building, 'healthcare', isTemp, end, buildingLabel, 'ADDRESS');
                this.showToast = end !== null ? false : true;
            } else {
                this.setPoint(building, 'healthcare', false, 0, buildingLabel, 'ADDRESS');
                this.requestsType[0] = requestType;
            }
            this.helpersService.close('modalComponentSS');
            this.modalEnd = null;
            this.wait = false;
        }
    }

    confirmAddress(event, index) {
        this.wait = true;
        if (event && event.isValid) {
            if (this.config.bts.load) {
                this.checkIfBts(event.point, index);
            } else if (this.config.school.load) {
                // this.setPoint(event.point, 'address', false, index, null, 'ADDRESS');
                this.checkIfBuildingSchool(event.point, index);
            } else if (this.config.healthcare.load) {
                this.checkIfHealthcare(event.point, index);
            } else {
                this.checkIfBuilding(event.point, index, null, null, 'address', 'ADDRESS');
            }
            this.pointFromModalSanita = true;
            this.labels[index] = event.point.formatted_address;
        } else {
            this.selectedPoints[index] = null;
            this.map.selectedPoints[index] = null;
            this.labels[index] = '';
            const content = 'The searched address is not in a valid format. Please select a suggested one.';
            this.helpersService.handleError(null, content);
            this.wait = false;
        }
    }

    // function triggered by selecting from the autocomplete
    confirmPopOrPoi(event, index) {
        this.wait = true;

        if (event && event.isValid) {
            if (event.point.tipologia_building === 'POI') {
                this.poiByCityLabels[index] = event.point.fullname
                this.poiLabels[index] = event.point.fullname
                this.setPoint(event.point, event.point.original_type || 'poi', false, index, null, 'POI');
            } else {
                this.popByCityLabels[index] = event.point.nome
                this.popLabels[index] = event.point.nome
                this.setPoint(event.point, event.point.original_type || 'pop', false, index, null, 'POP');
            }
        } else {
            this.selectedPoints[index] = null;
            this.map.selectedPoints[index] = null;

            if (event?.point?.tipologia_building === 'POI') {
                this.poiLabels[index] = '';
                this.poiByCityLabels[index] = '';
            }

            if (event?.point?.tipologia_building === 'POP') {
                this.popLabels[index] = '';
                this.popByCityLabels[index] = '';
            }

            const content = 'The searched address is not in a valid format. Please select a suggested one.';
            this.helpersService.handleError(null, content);
            this.wait = false;
        }

        this.blurInputElements()
    }

    confirmPop(event, index) {
        this.wait = true;

        if (event && event.isValid) {
            this.popByCityLabels[index] = event.point.nome
            this.popLabels[index] = event.point.nome
            this.setPoint(event.point, 'pop', false, index, null, 'POP');
        } else {
            this.selectedPoints[index] = null;
            this.map.selectedPoints[index] = null;
            this.popLabels[index] = '';
            this.popByCityLabels[index] = '';

            const content = 'The searched address is not in a valid format. Please select a suggested one.';
            this.helpersService.handleError(null, content);
            this.wait = false;
        }

        this.blurInputElements()
    }

    confirmPfs(event, index?) {
        this.wait = true;
        if (event && event.isValid) {
            this.setPoint(event.point, 'pfs', false, index, null, 'PFS');
        } else {
            this.selectedPoints[index] = null;
            this.map.selectedPoints[index] = null;
            this.labels[index] = '';
            const content = 'The searched address is not in a valid format. Please select a suggested one.';
            this.helpersService.handleError(null, content);
            this.wait = false;
        }
    }

    confirmRoe(event, index?) {
        this.wait = true;
        if (event && event.isValid) {
            this.setPoint(event.point, 'roe', false, index, null, 'ROE');
        } else {
            this.selectedPoints[index] = null;
            this.map.selectedPoints[index] = null;
            this.labels[index] = '';
            const content = 'The searched address is not in a valid format. Please select a suggested one.';
            this.helpersService.handleError(null, content);
            this.wait = false;
        }
    }

    setElementByCoordinates(point, index) {
        if (this.config.bts.load) {
            this.checkIfBts(point, index);
        } else {
            this.checkIfBuilding(point, index, this.setCoordinates(point).lat, this.setCoordinates(point).lng);
        }
    }

    isEnabledOnThisInput(index, researchMethod) {
        return this.config.multiple_points.points[index > 0 ? 'a_end' : 'b_end'][researchMethod] ? true : false;
    }

    confirmCoordinates(event, index?) {
        this.wait = true;
        this.geocoderResults = null;
        this.isAnnoBandoDropdownVisible = false;
        if (event) {
            if (event.isValid) {

                this.labels[index] = event.point.formatted_address;

                let latLng = this.setCoordinates(event.point);
                this.geocoder.geocode({ location: latLng, 'region': 'it' }, (results, status) => {
                    this.geocoderResults = {
                        results: results,
                        status: status
                    };
                    const p: any = event.point;
                    let types = [];
                    if (this.config.bts.types !== null && this.config.bts.types.NOA?.click && this.isEnabledOnThisInput(index ? index : 0, 'id_bts_noa')) {
                        types.push('NOA');
                    }
                    if (this.env.controls.agf && this.config.bts.types !== null && this.config.bts.types.BUILDING?.click && this.isEnabledOnThisInput(index ? index : 0, 'id_bts_building')) {
                        types.push('BUILDING');
                    }
                    if (this.config.bts.types !== null && event.point.coordinates && types.length) {
                        this.landingPageService.getBtsByCoordinates(event.point.coordinates.lat(), event.point.coordinates.lng(), types).subscribe(res => {
                            if (res && res.results) {
                                // se c'è un solo elemento
                                if (res.results.BUILDING && res.results.BUILDING.length === 1 && (!res.results.NOA || !res.results.NOA.length)) {
                                    this.map?.map.setCenter(res.results.BUILDING[0].coordinates);
                                    this.map?.map.setZoom(10);
                                    this.storeBts('BTS_BUILDING', res.results.BUILDING[0], res.results.BUILDING[0].points[res.results.BUILDING[0].code], index);
                                    this.assignSwitchValue(index, 'bts_building')
                                } else if (res.results.NOA && res.results.NOA.length === 1 && (!res.results.BUILDING || !res.results.BUILDING.length)) {
                                    this.map?.map.setCenter(res.results.NOA[0].coordinates);
                                    this.map?.map.setZoom(10);
                                    this.storeBts('BTS_NOA', res.results.NOA[0], null, index);
                                    this.assignSwitchValue(index, 'bts_noa')
                                }
                                // // se c'è più di un elemento
                                else if ((res.results.BUILDING && res.results.BUILDING.length > 1) || (res.results.NOA && res.results.NOA.length > 1) || (res.results.BUILDING && res.results.NOA && res.results.BUILDING.length >= 1 && res.results.NOA.length >= 1)) {
                                    this.modalPoints = res.results;
                                    this.modalEnd = index;
                                    this.zone.run(() => {
                                        this.modalMultiPoints.open(this.modalPoints);
                                    })
                                } else {
                                    this.setPoint(event.point, 'coordinates', false, index, event.point.formatted_address, 'Coordinates');
                                }
                            } else {
                                this.setPoint(event.point, 'coordinates', false, index, event.point.formatted_address, 'Coordinates');
                            }
                        });
                    } else if (this.config.school.click && event.point.coordinates) {
                        this.landingPageService.getSchoolsByCoordinates(event.point.coordinates.lat(), event.point.coordinates.lng()).subscribe(res => {
                            this.modalScuoleSanita = [];
                            if (res && res.results && res.results.length) {
                                this.onFilteredList(res.results, this.schoolForMap);
                                if (res.results.length > 1) {
                                    this.modalScuoleSanita = res.results;
                                    this.pointFromModal = true;
                                    this.zone.run(() => {
                                        this.modalComponentSS.open(this.modalScuoleSanita, 'school');
                                    })
                                }
                                if (res.results.length === 1) {
                                    this.storePoint(res.results[0], 'school', index, 'coordinates');
                                }
                            } else {
                                if (res.results.length === 0) {
                                    this.menageAnnoBandoOptions(event.point);
                                    this.setPoint(event.point, 'coordinates', false, index, event.point.formatted_address, 'Coordinates');
                                    this.isAnnoBandoDropdownVisible = true;
                                } else {
                                    const content = 'The searched coordinates do not match a school.';
                                    this.helpersService.handleError(null, content);
                                }
                            }
                        });
                    } else if (this.config.healthcare.click && event.point.coordinates && this.isEnabledOnThisInput(index ? index : 0, 'id_healthcare')) {
                        this.landingPageService.getHealthcareByCoordinates(event.point.coordinates.lat(), event.point.coordinates.lng()).subscribe(res => {
                            this.modalScuoleSanita = [];
                            if (res && res.results && res.results.length) {
                                this.onFilteredList(res.results, this.healthcareForMap);
                                if (res.results.length > 1) {
                                    this.modalScuoleSanita = res.results;
                                    this.pointFromModal = true;
                                    this.modalEnd = index;
                                    this.zone.run(() => {
                                        this.modalComponentSS.open(this.modalScuoleSanita, 'healthcare');
                                    })
                                } else {
                                    this.pointFromModal = true;
                                    let method = this.requestsType[index ? index : 0] == 'coordinates' ? 'COORDINATES' : 'ADDRESS';
                                    if (this.config.multiple_points.max > 1) {
                                        const isTemp = index !== null ? false : true;
                                        this.setPoint(res.results[0], 'healthcare', isTemp, index, null, method);
                                        this.requestsType[index] = 'address';
                                        this.showToast = index !== null ? false : true;
                                    } else {
                                        this.setPoint(res.results[0], 'healthcare', false, 0, null, method);
                                        this.requestsType[index] = 'address';
                                    }
                                    switch (method) {
                                        case 'ADDRESS':
                                            this.requestsType[index] = 'address';
                                            break;
                                        case 'COORDINATES':
                                            this.requestsType[index] = 'coordinates';
                                            break;
                                        default:
                                            this.requestsType[index] = 'id_healthcare';
                                            break;
                                    }
                                    this.helpersService.close('modalComponentSS');
                                    this.wait = false;
                                }
                                if (res.results.length === 1) {
                                    this.storePoint(res.results[0], 'healthcare', index, 'coordinates');
                                }
                            } else {
                                if (res.results.length === 0) {
                                    this.menageAnnoBandoOptions(event.point);
                                    this.setPoint(event.point, 'coordinates', false, index, event.point.formatted_address, 'Coordinates');
                                    this.isAnnoBandoDropdownVisible = true;
                                } else {
                                    const content = 'The searched coordinates do not match a healthcare point.';
                                    this.helpersService.handleError(null, content);
                                }
                            }
                        });
                    } else {
                        this.setElementByCoordinates(event.point, index);
                    }
                });
            } else {
                this.selectedPoints[index] = null;
                this.map.selectedPoints[index] = null;
                this.labels[index] = '';
                const content = 'The searched address is not in a valid format. Please select a suggested one.';
                this.helpersService.handleError(null, content);
                this.canAddPointsOptional();
                this.wait = false;
                if (this.coordinatesSearch && this.coordinatesSearch.filter((e, i) => i === index)[0]) {
                    this.coordinatesSearch.filter((e, i) => i === index)[0].reset();
                }
            }
        } else {
            this.selectedPoints[index] = null;
            this.map.selectedPoints[index] = null;
            this.map.removeMarkersByIndex(index);
            this.labels[index] = '';
            this.canAddPointsOptional();
            this.wait = false;
        }
    }

    confirmId(event, index) {
        this.wait = true;
        if (!event && index >= 0) {
            this.map.removeMarkersByIndex(index);
            this.selectedPoints[index] = null;
            this.map.selectedPoints[index] = null;
            this.labelsRpi[index] = '';
            this.labels[index] = '';
            this.wait = false;
            return;
        }
        if (event) {
            if (this.requestsType[index] === 'id_bts_noa') {
                if (event.includes('#')) {
                    event = event.replace('#', '');
                }
                this.landingPageService.getBtsById('NOA', event).subscribe((res: Bts) => {
                    this.storeBts('BTS_NOA', res, null, index);
                })
            } else if (this.requestsType[index] === 'id_bts_building') {
                this.landingPageService.getBtsById('BUILDING', event).subscribe((res: Bts) => {
                    this.storeBts('BTS_BUILDING', res, res.points[res.code], index);
                })
            } else if (this.requestsType[index] === 'id_school') {
                this.landingPageService.getSchoolById(event).subscribe(res => {
                    this.onFilteredList([res], this.schoolForMap);
                    this.storePoint(res, 'school', index, 'building');
                })
            } else if (this.requestsType[index] === 'id_healthcare') {
                this.landingPageService.getHealthcareById(event).subscribe(res => {
                    this.onFilteredList([res], this.healthcareForMap);
                    this.storePoint(res, 'healthcare', index, 'building');
                })
            } else if (this.requestsType[index] === 'id_building') {
                this.landingPageService.getBuildingById(event).subscribe(res => {
                    if (res.type === 'Designed') {
                        const msg = 'Unable to find Building ' + event;
                        this.helpersService.handleError(null, msg);
                        this.wait = false;
                    } else {
                        this.setPoint(res, 'building', false, index, res.id_building ? res.id_building : res.id, 'BUILDING');
                        this.requestsType[index] = 'id_building';
                    }
                })
            } else if (this.requestsType[index] === 'punti_intermedi' && this.requestsTypeRpi[index] === 'id_rpi') {
                this.landingPageService.getNetworkLinkPointById(event, this.searchedType.key).subscribe((res: any) => {
                    this.setPoint(res, this.searchedType.key, false, 0, res.code, this.searchedType.key);
                    this.labels[index] = this.searchedType.value;
                })
            } else if (this.requestsType[index] === 'pop_pcn_xpop' && this.requestsTypeWavelength[index] === 'id_wavelength') {
                this.landingPageService.getNetworkLinkPointById(event, this.searchedType.key).subscribe((res: any) => {
                    this.setPoint(res, this.searchedType.key, false, 0, res.code, this.searchedType.key);
                    this.labels[index] = this.searchedType.value;
                })
            } else {
                const content = 'The searched address is not in a valid format. Please select a suggested one.';
                this.helpersService.handleError(null, content);
                this.selectedPoints[index] = null;
                this.map.selectedPoints[index] = null;
                this.labels[index] = '';
                this.wait = false;
            }
        } else {
            const content = 'The searched address is not in a valid format. Please select a suggested one.';
            this.helpersService.handleError(null, content);
            this.selectedPoints[index] = null;
            this.map.selectedPoints[index] = null;
            this.labels[index] = '';
            this.wait = false;
        }
    }

    onClickedBuilding(event) {
        if (this.config.multiple_points.max > 1) {
            this.setPoint(event, 'building', true, null, event.address, 'BUILDING');
            this.showToast = true;
        } else {
            this.setPoint(event, 'building', false, 0, event.address, 'BUILDING');
        }
    }

    onClickPop(event) {
        this.wait = true;
        const end = this.config.multiple_points.initial_points[0];
        if (!this.isMethodEnabled(end as PointSide, 'pop') && !this.selectedPoints[1]) {
            const errorMessage = 'Cannot select a POP as B-END. Add a A-END first.';
            this.helpersService.handleError(null, errorMessage);
            this.wait = false;
            return;
        }
        if (!this.pointsConfig[end].pop && !this.selectedPoints[1]) {
            const errorMessage = 'Cannot select a POP as B-END. Add a A-END first.';
            this.helpersService.handleError(null, errorMessage);
            this.wait = false;
            return;
        }

        if (this.isTrasloco) {
            this.popLabels[this.endEditablePoint] = event.nome;
            this.setPoint(
                event,
                'pop',
                false,
                this.endEditablePoint,
                null,
                'POP'
            );
            return;
        }
        const isTemp = this.config.multiple_points.max > 1;

        // SINGLE POINT
        if (!isTemp) {
            this.assignSwitchValue(0, 'pop', true)
            this.popLabels[0] = event.nome;
            this.popByCityLabels[0] = event.nome;
        }

        // MULTI POINT
        if (end === 'b_end') {
            const popAndPoiAutocomplete = this.pointsConfig[end]?.popAndPoiAutocomplete;
            if (popAndPoiAutocomplete) {
                this.poiLabels[0] = event.nome;
            }
        }

        this.setPoint(
            event,
            'pop',
            isTemp,
            isTemp ? null : 0,
            null,
            'POP'
        );
        this.showToast = isTemp;
    }

    onClickRpi(event, type) {
        this.resetPoint('punti_intermedi')
        this.searchedType = { key: type, value: Utils.PUNTI_INTERMEDI_LABELS[type] };
        this.setPoint(event, type.toLowerCase(), false, 0, null, type);
        this.labels[0] = this.searchedType.value;

        this.requestsTypeRpi[0] = 'id_rpi';
        this.labelsRpi[0] = event.code;
    }

    onClickWavelength(event, type) {
        this.resetPoint('pop_pcn_xpop')
        this.searchedType = { key: type, value: Utils.POP_PCN_XPOP_LABELS[type] };
        this.labels[0] = this.searchedType.value; // index not managed for now
        this.setPoint(event, type.toLowerCase(), false, 0, null, type);
        this.requestsTypeWavelength[0] = 'id_wavelength';
        this.labelsWavelength[0] = event.code;
    }

    onClickPfs(event) {
        this.wait = true;
        // se non è stato generato un A-END e non è possibile selezionare questo elemento come B-END
        const end = this.config.multiple_points.initial_points[0];
        if (!this.pointsConfig[end].pfs && !this.selectedPoints[1]) {
            const errorMessage = 'Cannot select a PFS as B-END. Add a A-END first.';
            this.helpersService.handleError(null, errorMessage);
            this.wait = false;
        } else {
            if (this.isTrasloco) {
                this.setPoint(event, 'pfs', false, this.endEditablePoint, null, 'PFS');

            } else {
                let isTemp = this.config.multiple_points.max > 1 ? true : false;
                this.setPoint(event, 'pfs', isTemp, isTemp ? null : 0, null, 'PFS');
                this.showToast = isTemp;
            }
        }
    }

    onClickRoe(event) {
        if (this.pointsConfig['b_end']?.punti_intermedi) {
            this.onClickRpi(event, 'ROE');
        } else {
            this.wait = true;
            // se non è stato generato un A-END e non è possibile selezionare questo elemento come B-END
            const end = this.config.multiple_points.initial_points[0];
            if (!this.pointsConfig[end].roe && !this.selectedPoints[1]) {
                const errorMessage = 'Cannot select a ROE as B-END. Add a A-END first.';
                this.helpersService.handleError(null, errorMessage);
                this.wait = false;
            } else {
                if (this.isTrasloco) {
                    this.setPoint(event, 'roe', false, this.endEditablePoint, null, 'ROE');

                } else {
                    let isTemp = this.config.multiple_points.max > 1 ? true : false;
                    this.setPoint(event, 'roe', isTemp, isTemp ? null : 0, null, 'ROE');
                    this.showToast = isTemp;
                }
            }
        }
    }

    onClickPoi(event) {
        console.log(event)
        this.wait = true;

        // se non è stato generato un A-END e non è possibile selezionare questo elemento come B-END
        const end = this.config.multiple_points.initial_points[0];

        if (!this.isMethodEnabled(end as PointSide, 'poi') && !this.selectedPoints[1]) {
            const errorMessage = 'Cannot select a POI as B-END. Add a A-END first.';
            this.helpersService.handleError(null, errorMessage);
            this.wait = false;
            return;
        }

        // se non è stato generato un A-END e non è possibile selezionare questo elemento come B-END
        if (!this.pointsConfig[end].poi && !this.selectedPoints[1]) {
            const errorMessage = 'Cannot select a POI as B-END. Add a A-END first.';
            this.helpersService.handleError(null, errorMessage);
            this.wait = false;
            return;
        }

        if (this.isTrasloco) {
            this.poiLabels[this.endEditablePoint] = event.fullname;

            this.setPoint(
                event,
                'poi',
                false,
                this.endEditablePoint,
                null,
                'POI'
            );
            return;
        }

        const isTemp = this.config.multiple_points.max > 1;

        // SINGLE POINT
        if (!isTemp) {
            this.assignSwitchValue(0, 'poi', true)
            this.poiLabels[0] = event.fullname;
        }

        // MULTI POINT
        if (end === 'b_end') {
            const popAndPoiAutocomplete = this.pointsConfig[end]?.popAndPoiAutocomplete;

            if (popAndPoiAutocomplete) {
                this.popLabels[0] = event.fullname;
            }
        }

        this.setPoint(
            event,
            'poi',
            isTemp,
            isTemp ? null : 0,
            null,
            'POI'
        );

        this.showToast = isTemp;
    }

    storeBts(type, event, label, index?, isTemp?) { // index optional bc noa can be intercepted by coordinates
        const temp = (isTemp !== null && isTemp !== undefined) ? isTemp : (this.config.multiple_points.max > 1 ? true : false);
        if (temp) {
            if (index >= 0) {
                this.setPoint(event, type, false, index, label, 'id_bts_noa');
                this.assignSwitchValue(index, 'id_' + type.toLowerCase());
            } else {
                this.setPoint(event, type, true, null, label, 'id_bts_noa');
                this.showToast = true;
            }
        } else {
            this.setPoint(event, type, false, index ? index : 0, label, 'id_bts_noa');
            this.assignSwitchValue(index ? index : 0, 'id_' + type.toLowerCase());
        }
        this.modalEnd = null;
        this.helpersService.close('multiPointsModal');
    }

    storePoint(event, type, index?, metod?) {
        if (this.config.multiple_points.max > 1) {
            if (index >= 0) {
                this.setPoint(event, type, false, index, null, metod);
            } else {
                this.setPoint(event, type, true, null, null, metod);
                this.showToast = true;
            }
        } else {
            this.setPoint(event, type, false, 0, null, metod);
        }
    }

    toggleMapButton(type) {
        this.landingPageService.mapButtons[type].active = !this.landingPageService.mapButtons[type].active;
        this.map.setMapButton(type);
    }

    openLegenda() {
        this.dialog.open(LegendaComponent, {
            panelClass: 'legendaModal',
            data: this.config
        });
    }

    onClickUploadInput(requestType?) {
        this.dialog.open(DialogUploadComponent, {
            panelClass: 'uploadDialogComponent',
            data: {
                bea_max_points: this.max_points,
                research_method: requestType,
            }
        });
    }

    public uploadFile(massiveBeaUpload: boolean) {
        this.landingPageService.uploadFile(this.savedFile, massiveBeaUpload).subscribe(res => {
            if (this.env.controls.massive_import_two_steps) {
                this.helpersService.showSuccess(`Una volta elaborato, ti invieremo una notifica per mail`, `Allegato inviato con successo!`);
                this.onCancelFile();
            } else {
                window.location.replace(res.url);
            }
        });
    }

    onCancelFile() {
        this.landingPageService.fileToUpload = null;
    }

    checkFeasibility() {

        this.requestArray = [];
        for (let i = 0; i < this.selectedPoints.length; i++) {
            if (this.selectedPoints[i] && this.selectedPoints[i].coordinates) {
                let point = this.selectedPoints[i];
                let request = new CheckFeasibilityRequest({
                    coordinates: {
                        type: 'Point',
                        coordinates: [point.coordinates.lng, point.coordinates.lat]
                    },
                    label: point.label ? point.label : null,
                    id: point.id ? point.id : null,
                    type: Utils.REQUEST_TYPES[(point.type).toLowerCase()],
                    comune: point.comune ? point.comune : null,
                    provincia: point.provincia ? point.provincia : null,
                    cap: point.cap ? point.cap : null,
                    street: point.street ? point.street : point.address,
                    street_number: point.street_number ? point.street_number : null,
                    research_method: point.research_method ? point.research_method : null,
                    //aggiungo anno bando solamente al primo
                    anno_bando: (this.isAnnoBandoDropdownVisible && this.annoBando && i == 0) ? this.annoBando.toString() : null,
                });
                this.requestArray.push(request)
            }
        }

        let queryParamsToSend: { id_risorsa: string | null, mode: ModeType | null, index: string | null } = {
            id_risorsa: null,
            mode: null,
            index: null
        };

        if (this.idRisorsa) {
            //trasloco
            if (this.isTrasloco && this.tmpIdTrasloco) {
                queryParamsToSend.id_risorsa = this.tmpIdTrasloco;
                if (this.mode === 'edit' || this.mode === 'add') {
                    queryParamsToSend.mode = this.mode;
                }
            }

            //long distance
            if (this.isLongLineCheck) {
                queryParamsToSend.id_risorsa = this.idRisorsa;
                if (this.mode === 'div' || this.mode === 'acc') {
                    queryParamsToSend.mode = this.mode;
                    queryParamsToSend.index = this.index ?? null;
                }
            }
        }

        let input = {
            points: this.requestArray,
            id_risorsa: queryParamsToSend.id_risorsa ?? null,
            mode: queryParamsToSend.mode ?? null,
            index: queryParamsToSend.index ?? null,
            service_type: null,
            service_sub_type: null,
            access_type: null,
            at_request_of: null,
            project: null,
        };

        this.landingPageService.checkFeasibility(input).subscribe(res => {
            window.location.replace(res.url);
        }, error => {
            this.helpersService.handleError(error);
        });

    }

    onMapZoom(zoom: number) {
        this.manageBuildings();
        this.map.setMapButton('pops');
        this.map.setMapButton('poi');
        if (this.map && zoom == this.config.map.clear_markers_zoom_level) {
            this.map.resetAllMarkers(this.map.clusterMarkers);
        } else if (this.map && zoom < 12) {
            this.map.resetAllMarkers(this.map.clusterMarkers, 'clusters');
        }
        if (this.map && zoom < 8) {
            this.map.clearMarkers([this.map.noaMarkers]);
        }
    }

    onDragEnd(value: boolean) {

        this.manageBuildings();
    }

    onMapLoaded() {

        this.manageBuildings();
    }

    manageBuildings() {
        const zoom = this.map.map.getZoom();
        const bounds = this.map.map.getBounds();

        if (bounds && (this.config.pop.load || this.config.pcn.load || this.config.pop_agf.load || this.config.pop_ola.load)) {
            this.wait = true;
            this.getPopBBox(zoom, bounds);
        }

        if (zoom >= 12 && bounds) {
            this.wait = true;

            if (this.config.building.load && !this.config.bts.types) {
                this.getBuildings(zoom, bounds);
            }

            if (this.config.bts.load && this.config.bts.types !== null) {
                let types = [];
                if (this.config.bts.types.NOA.load) {
                    types.push('NOA');
                }
                ;
                if (this.env.controls.agf && this.config.bts.types.BUILDING.load) {
                    types.push('BUILDING');
                }
                ;
                this.getBtsBbox(types, bounds, zoom);
            }
            if (this.config.punti_intermedi.load) {
                this.getPuntiIntermediBbox(this.puntiIntermediTypes, this.config.area_types_short, bounds, zoom);
            }
            if (this.config.school.load) {
                this.getSchoolBuildings(zoom, bounds);
            }
            if (this.config.healthcare.load) {
                this.getHealthcareBuildings(zoom, bounds);
            }
        }
    }


    getPopBBox(zoom: number, bounds: google.maps.LatLngBounds) {
        const bbox = this.getBBoxFromMap(bounds).flat

        if (this.getPopBBoxSubscription$ instanceof Subscription) {
            this.getPopBBoxSubscription$.unsubscribe();
        }

        this.getPopBBoxSubscription$ = this.landingPageService.getPops({ zoom, bbox }).subscribe(res => {
            if (res) {
                this.abPops = [];
                this.cdPops = [];
                this.agfPops = [];
                this.olaPops = [];
                const abPops = [];
                const cdPops = [];
                const agfPops = [];
                const olaPops = [];

                // const abPopTypes = ["Nazionale", "Primary", "Edge"];
                const cdPopTypes = ["Secondary"];
                const agfPopTypes = ["AGF"];
                const olaPopTypes = ["OLA"];

                res.forEach((p: Pop) => {
                    // if (abPopTypes.includes(p.type)) {
                    //     abPops.push(p);
                    // }
                    if (cdPopTypes.includes(p.type)) {
                        cdPops.push(p);
                    }
                    else if (agfPopTypes.includes(p.type)) {
                        agfPops.push(p);
                    }
                    else if (olaPopTypes.includes(p.type)) {
                        olaPops.push(p);
                    }
                    else {
                        abPops.push(p);
                    }
                });

                this.abPops = abPops;
                this.cdPops = cdPops;
                this.agfPops = agfPops;
                this.olaPops = olaPops;

                if (this.map && (this.config.pop.view_initial || this.config.pcn.view_initial || this.config.pop_agf.view_initial || this.config.pop_ola.view_initial)) {
                    this.map.abPops = abPops;
                    this.map.cdPops = cdPops;
                    this.map.agfPops = agfPops;
                    this.map.olaPops = olaPops;
                }
            } else {
                this.wait = false;
            }
        });
    }

    getBuildings(zoom, bounds) {
        if (this.searchBuildingPlaceholdersSubscription$ instanceof Subscription) {
            this.searchBuildingPlaceholdersSubscription$.unsubscribe();
        }
        this.searchBuildingPlaceholdersSubscription$ = this.landingPageService.searchBuildingPlaceholders(bounds, zoom).subscribe(res => {
            if (res && res.results) {
                this.buildingClusters = res;
                this.checkPointEnd = null;
                this.pointFromModal = false;
            } else {
                this.wait = false;
            }
        });
    }

    getBtsBbox(types, bounds, zoom) {
        if (this.getBtsBboxSubscription$ instanceof Subscription) {
            this.getBtsBboxSubscription$.unsubscribe();
        }
        this.getBtsBboxSubscription$ = this.landingPageService.getBtsBbox(types, bounds, zoom).subscribe(res => {
            if (res.results) {
                this.btsClusters = res;
                if (this.checkPointEnd !== null && !this.pointFromModal) {
                    const point = this.selectedPoints[this.checkPointEnd];
                    if (point.type != 'Building') {
                        // this.checkIfBts(point, this.checkPointEnd);
                    }
                } else {
                    this.wait = false;
                }
                this.checkPointEnd = null;
                this.pointFromModal = false;
            }
            this.wait = false;
        });
    }

    getPuntiIntermediBbox(types, clusters, bounds, zoom) {
        this.puntiIntermediClusters = [];
        if (this.getPuntiIntermediBboxSubscription$ instanceof Subscription) {
            this.getPuntiIntermediBboxSubscription$.unsubscribe();
        }
        this.getPuntiIntermediBboxSubscription$ = this.landingPageService.getPuntiIntermediBbox(types, clusters, bounds, zoom).subscribe(res => {
            this.puntiIntermediClusters = [];
            if (res && res.results && (res.results.POZZETTO || res.results.ROE || res.results.CNO)) {
                this.puntiIntermediClusters = res;
                this.checkPointEnd = null;
                this.pointFromModal = false;
            }
            this.wait = false;
        });
    }

    getSchoolBuildings(zoom, bounds) {
        if (this.getSchoolSubscription$ instanceof Subscription) {
            this.getSchoolSubscription$.unsubscribe();
        }
        this.getSchoolSubscription$ = this.landingPageService.searchSchoolBBox(bounds, zoom).subscribe(schoolBBox => {
            this.schoolClusters = schoolBBox;
            this.wait = false;
            if (schoolBBox && schoolBBox.results) {
                if (this.checkPointEnd !== null && !this.pointFromModal) {
                    const point = this.selectedPoints[this.checkPointEnd];
                    if (point.type != 'Building') {
                        // this.checkIfBuildingSchool(point, this.checkPointEnd);
                    }
                } else {
                    this.wait = false;
                }
                this.checkPointEnd = null;
                this.pointFromModal = false;
            } else {
                this.wait = false;
            }
        });
    }

    getHealthcareBuildings(zoom, bounds) {
        if (this.getHealthcareSubscription$ instanceof Subscription) {
            this.getHealthcareSubscription$.unsubscribe();
        }
        this.getHealthcareSubscription$ = this.landingPageService.searchHealthcareBBox(bounds, zoom).subscribe(
            healthcareBBox => {
                this.healthcareClusters = healthcareBBox;
                this.wait = false;
                if (healthcareBBox && healthcareBBox.results) {
                    if (this.checkPointEnd !== null && !this.pointFromModal) {
                        const point = this.selectedPoints[this.checkPointEnd];
                        if (point.type != 'Building') {
                            // this.checkIfBuildingHealthcare(point, this.checkPointEnd);
                        }
                    } else {
                        this.wait = false;
                    }
                    this.checkPointEnd = null;
                    this.pointFromModal = false;
                } else {
                    this.wait = false;
                }
            });
    }

    onSelectBts(ev, index, isTemp?) {
        this.wait = true;
        const event = ev.point ? ev.point : ev;
        const element = event.element ? event.element : event;
        if (element.points && Object.keys(element.points).length > 1) {
            let types = [];
            if (this.config.bts.types !== null && this.config.bts.types.NOA?.click && this.isEnabledOnThisInput(index ? index : 0, 'id_bts_noa')) {
                types.push('NOA');
            }
            if (this.env.controls.agf && this.config.bts.types !== null && this.config.bts.types.BUILDING?.click && this.isEnabledOnThisInput(index ? index : 0, 'id_bts_building')) {
                types.push('BUILDING');
            }
            this.landingPageService.getBtsByCoordinates(element.coordinates.lat, element.coordinates.lng, types).subscribe(res => {
                if ((res.results.BUILDING && res.results.BUILDING.length > 1) || (res.results.NOA && res.results.NOA.length > 1) || (res.results.BUILDING && res.results.NOA && res.results.BUILDING.length >= 1 && res.results.NOA.length >= 1)) {
                    this.modalPoints = res.results;
                    this.modalEnd = index;
                    this.zone.run(() => {
                        this.modalMultiPoints.open(this.modalPoints);
                    })
                }
            });
        }
        const type = element.pointType ? element.pointType : element.point_type;
        const label = type.toLowerCase() === 'noa' ? '#' + element.id : element.points[element.code];
        let temp;
        if (isTemp !== null && isTemp !== undefined) {
            temp = isTemp;
        } else if (this.selectedPoints.length > 1 && this.selectedPoints[0] && this.isEnabledOnThisInput(0, 'id_bts' + type.toLowerCase()) && this.selectedPoints[1] && this.isEnabledOnThisInput(1, 'id_bts' + type.toLowerCase())) {
            temp = true;
        } else {
            temp = false;
        }
        this.resetPoint('id_bts_' + type.toLowerCase(), index);
        this.storeBts('BTS_' + type.toUpperCase(), element, label, index, temp);

    }

    onClickModaleSS(data: any) {
        if (this.config.school.load) {
            this.resetPoint('id_school');
            this.storePoint(data, 'school');
        }
        if (this.config.healthcare.load) {
            this.resetPoint('id_healthcare');
            this.storePoint(data.building, 'healthcare', data.end ? data.end : 0);
        }
        this.wait = false;
        this.helpersService.close('modalComponentSS');
    }

    placePointPreview(latLng: google.maps.LatLng) {
        if (this.map.map.getZoom() >= 12) {
            this.geocoder.geocode({ location: latLng }, (res) => {
                res[0].geometry.location = latLng;
                const point = res[0];
                if (this.config.multiple_points.max > 1) {
                    if (this.isTrasloco) {
                        this.setPoint(point, 'address', false, this.endEditablePoint, null, 'POINT');
                    } else {

                        this.setPoint(point, 'address', true, null, null, 'POINT');

                        this.showToast = true;
                    }
                    setTimeout(() => {
                        this.showToast = false;
                    }, 4000);
                }
            });
        }
    }

    public onSelectPlaceFromToast(point, index, type) {
        // if(this.isTrasloco){
        //   this.tempPoint.isTemp = false;
        //   this.tempPoint.type = type.toLowerCase();
        //   this.tempPoint.end = index;
        // }else{
        this.tempPoint.isTemp = false;
        this.tempPoint.type = type.toLowerCase();
        this.tempPoint.end = index;
        // }

        if (type.toLowerCase() === 'pop') {
            this.assignSwitchValue(index, 'pop', true)
            this.popLabels[index] = point.visible_label;
        }
        if (type.toLowerCase() === 'poi') {
            this.assignSwitchValue(index, 'poi', true)
            this.poiLabels[index] = point.visible_label;
        }

        this.selectedPoints[index] = this.tempPoint;
        this.labels[index] = point.visible_label;

        if (point.indirizzo && point.indirizzo.id) {
            this.assignSwitchValue(index, 'address')
        } else {
            this.assignSwitchValue(index, type.toLowerCase());
        }

        this.setPointDynamicAend(point, index);
        this.canAddPointsOptional();
        this.map.showMarker(this.tempPoint, index);
        this.closeToast(false);
    }

    public closeToast(removePoint) {
        this.showToast = false;
        if (this.config.multiple_points.max > 1) {
            this.tempPoint = null;
            this.map.removeMarkersTemp()
            if (removePoint) {
                if (this.selectedPoints[0] && !this.selectedPoints[1]) {
                    this.selectedPoints[0] = null;
                    this.map.selectedPoints[0] = null;
                    this.labels[0] = '';
                }
            }
        }
    }

    resetPoint(newType, index = 0) {
        this.requestsType[index] = newType;

        if (this.poiByCityLabels[index]) {
            this.poiByCityLabels[index] = null;
        }

        if (this.poiLabels[index]) {
            this.poiLabels[index] = null;
        }

        if (this.popByCityLabels[index]) {
            this.popByCityLabels[index] = null;
        }

        if (this.popLabels[index]) {
            this.popLabels[index] = null;
        }

        if (this.cityLabelPoi[index]) {
            this.cityLabelPoi[index] = null;
        }

        if (this.cityLabelPop[index]) {
            this.cityLabelPop[index] = null;
        }

        if (newType === 'import' || newType === 'import_bea') {
            //todo aggiungere qui il controllo per controllare il switch value
            if (this.env.serviceSlug == 'bea') {
                this.removeInputsForBea();
            } else {
                for (let i = 1; i < this.inputsNumber; i++) {
                    this.removeSearchInput(i);
                }
                this.searchedType = { key: null, value: null }; // remove punto intermedio type
                this.labelsRpi[index] = null;

            }
        } else {
            if (newType === 'city_building') {
                this.loadBtsCities(['BUILDING']);
            }
            if (newType === 'city_noa') {
                this.loadBtsCities(['NOA']);
            }
            // reset other inputs as initial
            if (this.config.multiple_points.initial_points.length > 1 && this.inputsNumber < this.config.multiple_points.initial_points.length) {
                this.config.multiple_points.initial_points.slice(1).forEach(p => {
                    if (this.config.multiple_points.initial_points.length - this.inputsNumber > 0) {
                        this.addSearchInput(p);
                    }
                });
            }
        }

        this.map.removeMarkersByIndex(index);
        this.selectedPoints[index] ?? null;
        this.map.selectedPoints[index] ?? null;
        this.labels[index] ?? '';

        if (this.cities[index]) {
            this.cities[index] = null;
        }

        if (this.btsLists && this.btsLists[index]) {
            this.btsLists[index].NOA = [];
        }

        this.confirmCoordinates(null, index)

        this.additionalAutocompletes[index] = false;
        this.canAddPointsOptional();

        //reset anno bando
        this.annoBando = null;
        this.isAnnoBandoDropdownVisible = false;

        this.cdr.detectChanges()
    }

    onChangeRpiMethod(value, index) {
        if (value === 'id_rpi') {
            this.cities[index] = null;
        }
        this.labelsRpi[index] = '';
        this.map.removeMarkersByIndex(index);
    }

    onChangeWavelengthMethod(value, index) {
        if (value === 'id_wavelength') {
            this.cities[index] = null;
        }
        this.labelsWavelength[index] = '';
        this.map.removeMarkersByIndex(index);
    }

    public downloadTemplate(isBeaMultisite: boolean): void {
        //nel caso di massive import BEA uso la path specifica nella config
        const path = this.a_endCities && this.a_endCities.is_aend_allowed ?
            this.config.data.api.massiveImport.massiveDownloadPath_2p : isBeaMultisite ?
                this.config.data.api.massiveImport.massiveDownloadPathBEA :
                this.config.data.api.massiveImport.massiveDownloadPath;
        this.landingPageService.getExcelTemplate(path).subscribe(res => {
            Utils.createFileLink(
                res,
                'template',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
        });
    }


    addSearchInput(pointDefaultConfig) {
        this.selectedPoints.push(new Point);
        this.checkSwitchValues(this.inputsNumber);
        if (this.pointsConfig[pointDefaultConfig]) {
            this.requestsType[this.inputsNumber] = this.pointsConfig[pointDefaultConfig].default_method;
        }
        if (this.pointsConfig.b_end.punti_intermedi) { // for now this is the only check
            this.requestsTypeRpi[0] = 'city_rpi';
        }
        this.inputsNumber++;
    }

    removeSearchInput(index?) {
        this.selectedPoints.splice(index, 1);
        this.map.selectedPoints.splice(index, 1);
        this.labels.splice(index, 1);
        this.switchValues[index] = [];
        this.inputsNumber--;
        this.map.removeMarkersTemp();
        this.map.removeMarkersByIndex(index);
        if (this.selectedPoints.length === 1) {
            if (this.selectedPoints[0].coordinates) {
                this.map?.map.setCenter(this.setCoordinates(this.selectedPoints[0]));
            }
            this.map?.map.setZoom(18);
        }
    }

    removeInputsForBea() {
        this.selectedPoints = [];
        this.map.selectedPoints = [];
        this.labels = [];
        this.poiLabels = [];
        this.popLabels = [];
        this.map.removeMarkersTemp();
        for (let i = 1; i < this.inputsNumber; i++) {
            this.map.removeMarkersByIndex(i);
        }
        this.inputsNumber = 1;
        // this.map?.map.setZoom(18);
    }


    private setPointTrasloco(point, end) {
        this.pointTrasloco = point
        this.isEditable = point.is_editable;

        if (this.isEditable === true) {
            this.endEditablePoint = end;
            point.markerCoordinates = new google.maps.LatLng(point.markerCoordinates.lat, point.markerCoordinates.lng);
        } else {
            point.markerCoordinates = new google.maps.LatLng(point.markerCoordinates.lat, point.markerCoordinates.lng);
            this.setPointDynamicAend(point, end);
            this.canAddPointsOptional(false);


            this.map.removeMarkersTemp();
            this.selectedPoints[end] = point;
            if (!this.requestsTypeRpi[end] || !this.pointsConfig.b_end.punti_intermedi) {
                this.labels[end] = point.id_building ? point.id_building : point.label;

            } else {
                this.labelsRpi[end] = point.id_building ? point.id_building : point.label;

            }
            this.canAddPointsOptional();
            this.map.showMarker(point);

        }
    }

    decodeIdTrasloco(id) {
        this.landingPageService.getDataFromIdTrasloco(id, this.mode ? this.mode : 'edit').subscribe(res => {

            this.isTrasloco = true;
            this.tmpIdTrasloco = res.id_risorsa;
            this.mode = res.mode;

            //rimuovo dalla richiesta per ciclare
            delete res.id_risorsa;
            delete res.mode;

            //quando non ho edit lascio un oggetto vuoto per avere 1 input per l'aggiunta
            this.resKeys = this.mode === 'edit' ? Object.keys(res) : [{}];
            this.responseTmp = this.mode === 'edit' ? JSON.parse(JSON.stringify(res)) : [{}];


            if (res.p1) {
                let coordinates = this.setCoordinates(res.p1);
                let response = JSON.parse(JSON.stringify(res));
                response.p1.markerCoordinates = coordinates;
                response.p1.coordinates = coordinates;
                response.p1.end = 0;
                this.setPointTrasloco(response.p1, 0);
            }
            if (res.p2) {
                let coordinates = this.setCoordinates(res.p2);
                let response = JSON.parse(JSON.stringify(res));
                response.p2.markerCoordinates = coordinates;
                response.p2.coordinates = coordinates;
                response.p2.end = 1;
                this.addSearchInput('a_end');
                this.setPointTrasloco(response.p2, 1);
            }
            if (res.p3) {
                let coordinates = this.setCoordinates(res.p3);
                let response = JSON.parse(JSON.stringify(res));
                response.p3.markerCoordinates = coordinates;
                response.p3.coordinates = coordinates;
                response.p3.end = 2;
                this.addSearchInput('a_end');
                this.setPointTrasloco(response.p3, 2);
            }

        },
            (error) => {
                this.isTraslocoEnabled = error.isEnabled;
            });

    }

    objectLength(obj: any) {
        return Object.keys(obj || {}).length
    }

    getBBoxFromMap(bounds: google.maps.LatLngBounds): { ne: { lat: number, lng: number }, sw: { lat: number, lng: number }, flat: number[] } {
        const neLat = bounds.getNorthEast().lat()
        const neLng = bounds.getNorthEast().lng()
        const swLat = bounds.getSouthWest().lat()
        const swLng = bounds.getSouthWest().lng()

        return {
            ne: {
                lat: neLat, lng: neLng
            },
            sw: {
                lat: swLat, lng: swLng
            },
            flat: [neLng, neLat, swLng, swLat]
        }
    }

    checkAnnoBandoRequired() {
        if (this.config && this.config.data.service_slug) {
            this.annoBandoRequired = this.annoBandoRequiredList.includes(this.config.data.service_slug);
        }
    }


    getRegion(place: any): string | null {
        const components = place.address_components;
        if (!components) return null;

        const regionComponent = components.find(c =>
            c.types.includes('administrative_area_level_1')
        );

        let firstThreeLetters = regionComponent?.short_name.substring(0, 3);
        return firstThreeLetters || null;
    }


    menageAnnoBandoOptions(address?) {
        let region = (this.geocoderResults && this.geocoderResults.results) ? this.getRegion(this.geocoderResults?.results[0]) : this.getRegion(address);
        this.annoBandoOptions = this.bandi.regions[region] != null ? this.bandi.regions[region] : this.bandi["default"];
        this.wait = false;
    }

    selectRightEndForToast(): any {
        //Avoid the possibility of selecting in the multiple choice toast the point a_end to avoid inserting an ID in the second input
        let configurations = ["SANITA_PASSIVE"]; //todo Add any configurations with the same problem

        if (configurations.includes(this.config.data.dynamic_aend_name)) {
            return 0;
        } else return null;
    }

    isInputDisabled(i: number): boolean {
        if (this.env.serviceSlug !== 'kit') return false;

        const otherIndex = i === 0 ? 1 : 0;
        const otherPoint = this.selectedPoints[otherIndex];

        return !!otherPoint && Object.keys(otherPoint).length > 0;
    }


    private checkIfLongLineRequest() {
        let serviceSlugToCheck = ['darkfiber'] // aggiungere eventuali landing da controllare
        let isLandingToCheck = serviceSlugToCheck.includes(this.config.data.service_slug)
        if (this.isLongLineCheck && isLandingToCheck) {
            //nel caso vado ad aggiungere un altro input per permettere il check
            this.addSearchInput(this.config.multiple_points.initial_points[0])
        }
    }

        private isMethodEnabled(
        side: PointSide,
        method: ConfigPointMethodKey
    ): boolean {
        const cfg = this.pointsConfig?.[side];
        return Boolean(cfg && cfg[method]);
    }

}

// prettier-ignore-end
